

import React, { Component } from 'react';
import Select from 'react-select';
import Datetime from 'react-datetime';
import ReactDOM from "react-dom";
import Modal from 'react-responsive-modal';
import Datepicker from '../layouts/datepicker.js';
import 'react-dates/initialize';
import 'react-dates/lib/css/_datepicker.css';
import { AgGridReact } from '@ag-grid-community/react';
import "@ag-grid-enterprise/all-modules/dist/styles/ag-grid.css";
import "@ag-grid-enterprise/all-modules/dist/styles/ag-theme-balham.css";
import 'react-datetime/css/react-datetime.css';
import redirectURL from '../redirectURL';
import { Redirect } from 'react-router-dom';
import $ from 'jquery';
import 'jquery-ui/ui/core';
import 'jquery-ui/ui/widgets/datepicker';
import LoadingAreaLegs from './loadingarealegs.js';
// import BidDetailsScreen from './biddetailsscreen.js';
import Actionsforvendorcomponent from './actionsforvendorcomponent.js';
import Vendorparticipationscomponent from './vendorparticipationdetials.js';
import DraftComponent from './drafticonscomponent.js';
import Allactioncomponent from './allactioncomponent.js';
import Materialcomponent from './Materialviewcomponent.js';
import ViewTruck from './truckbtn.js';
import Allactioncomponentforvendor from './allactionsforvendorcomponent.js';
import BidButton from './bidbutton.js';
import AttachmentButton from './attahcmentbutton.js';
import CommentsButton from './commentsbutton.js';
import ViewRFQButton from './viewrfqdetails.js';
import CancelIndentButton from './cancelindentbtn.js';
import CommentsAllButton from './commentslogscomponent.js';
import NotificationButton from './notificationbtn.js';
import RFQView from './rfqpreviewcomponent.js';
import CountdownRenderer from './bidwindowstopwatchcomponent.js';
import CountdownRendererfornegotaition from './negotiationcutofftimercomponent.js';
import ParticipantsComponent from './participantscomponent.js';
import SweetAlert from 'react-bootstrap-sweetalert';
import Filter1 from '../../assets/icons/filters.svg'
import CountdownTimer from './runningtime.js';
import Indentvaliditycomponent from './indentvaliditycomponent.js';
import CountdownTimerforbid from './countdowntimerforbid.js';
//  import io from 'socket.io-client';
import { getHyphenDDMMYYYYHHMM, getHyphenDDMMYYYYHHMMSS, getHyphenYYYYMMDDHHMM, getHyphenDDMMYYYY } from '../common/utils';
import { onNewBid, emitDataReceived } from '../socketManager.js';
var moment = require('moment');
const customSelectStyles = {
  option: (provided) => ({
    ...provided,
    fontSize: '14px',
  }),
  singleValue: (provided) => ({
    ...provided,
    fontSize: '14px',
  }),
};
const userType = localStorage.getItem("user_type");

class IndentAuctionComponentforadmin extends Component {
  constructor(props) {
    super(props);
    const today = moment().format('YYYY-MM-DD');
    const oneWeekAgo = moment().subtract(30, 'days').format('YYYY-MM-DD');
    this.state = {
      redirect: false,
      bidDetailsform: false,
      startDate: null,
      endDate: null,
      open: false,
      selectedindent: {},
      draftdata: [],
      uploadpaymentterms: '',
      showConfirmationModal: false,
      confirmMessage: "",
      confirmActionCallback: null,
      checkfortext: false,
      defaultColDef: {
        sortable: true,
        filter: true,
        resizable: true
      },
      loadshow: "show-n",
      selectedTab: 'Active Indents',
      selectedSubTab: 'Bidding In Progress',
      overlay: "show-n",
      isInputOpen: {},
      vendorforrejected: [],
      showsweetalert: false,
      hoveredIconId: null,
      seletedtab: '',
      hidebidnowbtn: false,
      filterToggle: false,
      selectedfromdate: oneWeekAgo,
      selectedenddate: today,
      basicType: "",
      basicTitle: "",
      newBidRate: '',
      newBidQuantity: '',
      activeDateBtn: '',
      showTooltip: false,
      negotiatedetails: [],
      rfqform: {
        active: 'activet1',
        total: '',
        drafts: '',
        cancelled: '',
        myactivity: '',
        archieved: '',
        awarded: '',
        upcoming: '',
        selectedindentid: '',
        completed: '',
        current_bidding: 'activet',
        bidding_history: ''
      },
      biddetails: [],
      allindents: [],
      activetabdata: 0,
      bulkUploadModal: {
        overly: "show-n",
        bulkPrioritySlide: ""
      },
      filterdata: [],
      originalindents: [],
      alldata: [],
      indentsdata: [],
      rankingdetails: [],
      selected_bid_price: '',
      negotiate_value: '',
      selected_transit_days: '',
      transit_time: '',
      bidsdata: [],
      rankedBids: [],
      searchfilter: {},
      isCardOpen: "",
      cardforadminbifurcation: '',
      selectedTab: "Active Indents",
      selectedTabforparent: 'Active Indents',
      dataforadminbifur: [],
      rejectModel: "",
      cancelIndentModel: "",
      vehicleDetailsModel: "",
      selectedindentforvendor: {},
      indent_for_approve: [],
      indent_for_approve_for_bid: [],
      indent_for_approve_for_bid1: [],
      indentfortruckdetails: [],
      indent_for_approve1: [],
      lr_no_data: [],
      paramsforrejection: {},
      rejectionReasonbyapproval1: "",
      selecteddata: {},
      showAllRecords: false,
      bidHistory: [],
      inputTextValue: "",
      inputTextQuantity: "",
      negotiations: [],
      negotiationsHistory: [],
      isProposedInputOpen: "",
      isVendorInputOpen: "",
      additionalComments: "",
      modelForAdditionalComments: false,
      vendorQuotes: [],
      modelForShowBids: false,
      modelForNotifications: false,
      notificationUnread: [],
      notificationRead: [],
      modelForEditAssigned: false,
      rejectedVendorBid: "",
      rejectedVendorIndent: "",
      rejectionReason: "",
      rejectionReasonbyvendor: "",
      countersfortab: {
        activecount: 0,
        totalcount: 0,
        deliveredcount: 0,
        awardcount: 0,
        vendorrejectedcount: 0,
        vehicleplacementmissedcount: 0,
        draftscount: 0,
        rejectedcount: 0,
        expiredcount: 0
      },
      selectedChildTab: 'Bidding In Progress', // default sub-tab
      filteredChildData: [],

      subcountertab: {
        bidding_in_progress_data: [],
        waiting_for_approval_data: [],
        waiting_for_quote_data: []
      },
      selectedIndentData: [],
      selectedindentdata1: {},
      inputTextValues: {},        // { [vendor_email_id]: value }
      proposedDays: {},
      selectedVendorQuotes: [],
      isPreviewMode: false,
      rfqForm: {},
      dealers: [
        {
          dealer_code: "",
          dealer_name: "",
          dealer_city: "",
          dealer_state: "",
          dealer_pincode: "",
          materials: [
            {
              material_type: "",
              material_length: 0,
              material_breath: 0,
              material_height: 0,
              material_units: "cm",
              quantity: 0,
              basic_requirment: ''
            },
          ]
        },
      ],
      timeLeft: null,
      text: '',
      destinationdetails: [],
      rowData: [],

    };
    this.tooltipRef = null;
    this.dotsRef = null;
  }

  componentDidMount() {
    redirectURL.post('/consignments/getdeclinereasons').then((resp) => {
      let decline_reasons = resp.data
      let decline_reasons_list = []
      decline_reasons.forEach((e) => {
        decline_reasons_list.push({ 'label': e.label, 'value': e.value })
      })
      this.setState({
        declineionReasonsList: decline_reasons_list
      })
    })
    redirectURL.post('/consignments/getTruckTypeList').then((resp) => {
      let truck_list = resp.data;


      let truck_list_arr = truck_list.map(function (e) {
        return { label: e.label, value: e.value };
      });

      this.setState({
        truck_list: truck_list_arr
      });

    })

    this.fetchData();

    onNewBid((data) => {
      this.fetchData()
    })
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevState.allindents !== this.state.allindents) {
      this.transformIndentData();
    }
  }

  handleDatesSelected = (start, end) => {
    this.setState((prevState) => {
      let newFrom = prevState.selectedfromdate;
      let newTo = prevState.selectedenddate;

      if (start) {
        newFrom = start.format("YYYY-MM-DD");
      }
      if (end) {
        newTo = end.format("YYYY-MM-DD");
      }
      return {
        selectedfromdate: newFrom,
        selectedenddate: newTo
      };
    }, this.fetchInitialData);
  };

  refreshSelected = () => {
    const today = moment().format('YYYY-MM-DD');
    const oneWeekAgo = moment().subtract(30, 'days').format('YYYY-MM-DD');

    this.setState({
      selectedfromdate: oneWeekAgo,
      selectedenddate: today
    });
  };

  handleDatesChange = ({ startDate, endDate }) => {
    this.setState({ startDate, endDate });
  };
  onGridReady = (params) => {
    this.gridApi = params.api;
  }

  transformIndentData = () => {
    const transformedData = this.state.allindents.map(indent => {
      let destinationStr = '';
      let materialStr = '';

      try {
        const dest = JSON.parse(indent.destination || '[]');
        destinationStr = dest.map(d => d.dealer_city).join(', ');
        materialStr = dest.flatMap(d => d.materials || [])
          .map(m => m.material_type)
          .join(', ');

      } catch { }

      return {
        indent_id: indent.indent_id,
        draft_id: indent.draft_id,
        status: this.getStatusFromIndent(indent),
        source: indent.source,
        destination: destinationStr,
        bidding_window: indent.bidding_window,
        negotiation_window: indent.negotiation_window,
        material: materialStr,
        truck_type: indent.type === 'sea' ? indent.container_type : (indent.type_of_truck === 'others' ? indent.selected_truck_type : indent.type_of_truck),
        pickup_date: getHyphenDDMMYYYY(indent.pickup_date),
        quantity: `${indent.confirmed_quantity}/${indent.quantity}`,
        confirmed_value: indent.confirmed_value || 'N/A',
        base_price: indent.base_price || '0',
        total_km: indent.total_km || '0',
        bid_start_date: getHyphenDDMMYYYYHHMM(indent.bid_start_date),
        vendor_count: (indent.vendorquotes && indent.vendorquotes.length) || 0,
        quotation_validity_hours: indent.quotation_validity_hours,
        bidding_timer_ends: indent.bidding_timer_ends,
        negotiation_timer_ends: indent.negotiation_timer_ends,
        indent
      };
    });

    this.setState({ rowData: transformedData, transformIndentrowdata: transformedData });
  }
  fetchData = () => {
    this.fetchInitialData();
    this.getdraftdata();
  };
  getcountersforindents = (data, draftData) => {
    let indentsdata = data;
    let totaldata;
    let expireddata;
    const userRole = localStorage.getItem('roles');
    const currentUserEmail = localStorage.getItem('email');

    if (localStorage.getItem('rfq_role') == 'ADMIN') {
      expireddata = indentsdata.filter(e => e.rejected != 1 && e.indent_assigned != 1 && e.approved_changed_l2_as_l1 != 1)
      expireddata = expireddata.filter(item =>
        (
          this.isBiddingWindowExpired(item.bidding_window, item.create_date) && item.rejected != 1 &&
          item.vendorquotes.length === 0
        ) ||
        item.validity_end === 1 ||
        item.vehicle_placement_expiried === 1
      );
    } else {
      const username = localStorage.getItem('username');
      const userEmail = localStorage.getItem('email');

      expireddata = indentsdata.filter(item => {
        const vendorQuotes = item.vendorquotes || [];
        const isExpired =
          // item.validity_end === 1 ||
          item.vehicle_placement_expiried === 1 ||
          this.isBiddingWindowExpired(item.bidding_window, item.create_date);

        const notQuoted = !vendorQuotes.some(x => x.vendor_email_id === userEmail) && this.isBiddingWindowExpired(item.bidding_window, item.create_date) && item.previous_accepted_vendor != userEmail && (
          ((item.vendors_participation &&
            typeof item.vendors_participation === 'object' &&
            !item.vendors_participation.hasOwnProperty(username)) || !item.vendors_participation)
        )
        const userDeclined = item.vendors_participation &&
          item.vendors_participation.hasOwnProperty(username) &&
          item.vendors_participation[username] === "declined";
        const isBiddingExpired = this.isBiddingWindowExpired(item.bidding_window, item.create_date);

        const declinedByCurrentUser =
          item.vendors_participation &&
          item.vendors_participation.hasOwnProperty(username) &&
          item.vendors_participation[username] === 'declined';
        const expitedvaliddata = isBiddingExpired &&
          !vendorQuotes.some(q => q.vendor_email_id === userEmail) &&
          !userDeclined && item.rejected != 1 && item.validity_end == 1
        return ((isExpired) && !declinedByCurrentUser && item.rejected != 1 && item.indent_assigned != 1 && item.waiting_for_approval1 != 1 && item.approvedwithapproval2 != 1) && notQuoted
      });
      console.log(expireddata, 'expireddata')


    }


    let awardeddata = [];
    if (localStorage.getItem('user_type') === 'TRANSPORTER') {
      awardeddata = indentsdata.filter(e => e.accepted_vendor === localStorage.getItem('email') && e.vehicle_placement_expiried != 1 && e.rejected != 1);
      awardeddata = awardeddata.filter((e) => {
        if (e.vendorquotes && Array.isArray(e.vendorquotes)) {
          const vendorquote = e.vendorquotes.find(
            (quote) =>
              (quote.vendor_email_id === localStorage.getItem('email') &&
                quote.indent_rejected_by_vendor != 1 &&
                quote.indent_accepted_by_vendor === 1) ||
              quote.bid_winner == 1
          );
          return vendorquote !== undefined;
        }
      });
    } else {
      awardeddata = indentsdata.filter(e => e.indent_assigned == 1 && e.indent_rejected_by_vendor != 1 && e.vehicle_placement_expiried != 1 && e.indent_cancelled != 1 && e.rejected != 1);
    }

    let activedata = [];
    if (localStorage.getItem('user_type') === 'TRANSPORTER') {
      const userEmail = localStorage.getItem('email');

      activedata = indentsdata.filter((e) => {
        const hasValidVendorDetails = e.vendordetails && e.vendordetails.length > 0 && e.indent_assigned !== 1 && e.validity_end !== 1 && e.previous_accepted_vendor != userEmail && e.rejected !== 1;
        const hasPendingDifferentVendor = e.indent_pending_data && e.indent_pending_data.vendor_email_id !== userEmail;
        const hasPreviousDifferentVendorAndMatchingQuote =
          e.previous_accepted_vendor !== userEmail &&
          e.vendorquotes &&
          e.vendorquotes.some(f => f.vendor_email_id === userEmail) &&
          e.vendorquotes.find(g => g.bid_winner != 1) &&
          e.vendorquotes.find(g => g.pending_vendor_approval == 1)
        const isExpiredWithNoQuote =
          this.isBiddingWindowExpired(e.bidding_window, e.create_date) &&
          (!e.vendorquotes || !e.vendorquotes.some(q => q.vendor_email_id === userEmail))

        return (hasValidVendorDetails || hasPendingDifferentVendor || hasPreviousDifferentVendorAndMatchingQuote) && !isExpiredWithNoQuote;
      });
      console.log(activedata, 'activedata435')

      let username = localStorage.getItem('username');

      activedata = activedata.filter(
        (e) =>
          e.previous_accepted_vendor !== userEmail &&
          e.indentcancelledbyadmin !== 1 &&
          e.indent_cancelled !== 1 &&
          // e.accepted_vendor!=userEmail
          // e.indent_assigned != 1 &&
          // e.approvedwithapproval2 !== 1 &&
          e.rejected !== 1 &&
          (
            !e.vendors_participation || // if no participation object, allow
            !e.vendors_participation.hasOwnProperty(username) || // if no user key, allow
            e.vendors_participation[username] !== 'declined' // only check if both above are true
          )
      );
      console.log(activedata, 'activedata452')

      activedata = activedata.filter((e) => {
        const vendorquotes = e.vendorquotes || [];
        if (
          vendorquotes.length > 0 &&
          vendorquotes.some((quote) => quote.vendor_email_id === userEmail)
        ) {
          const vendorquote = vendorquotes.find((quote) => {
            const isValid =
              quote.vendor_email_id === userEmail &&
              quote.indent_rejected_by_vendor !== 1 &&
              quote.indent_accepted_by_vendor !== 1 &&
              quote.vendor_rejected !== 1
            return (
              isValid ||
              (isValid && e.waiting_for_approval1 == 1 && e.indent_assigned != 1)
            );
          });

          return vendorquote !== undefined;


          return vendorquote !== undefined;
        }

        return true;
      });
    } else {
      activedata = indentsdata.filter(e =>
        e.vendordetails &&
        e.vendordetails.length > 0 &&
        e.indent_assigned != 1 &&
        e.rejected != 1 &&
        e.indentcancelledbyadmin != 1 &&
        (
          e.vendorquotes.length > 0 ||
          !this.isBiddingWindowExpired(e.bidding_window, e.create_date)
        ) &&
        (
          e.validity_end != 1 || e.approved_changed_l2_as_l1 == 1
        )
      );

    }


    const completeddata = indentsdata.filter(e => e.validity_end == 1);

    let rejecteddata = [];
    if (localStorage.getItem('user_type') === 'TRANSPORTER') {
      const userEmail = localStorage.getItem('email');
      rejecteddata = indentsdata.filter(e => e.previous_accepted_vendor != localStorage.getItem('email') || e.rejected == 1)
      rejecteddata = rejecteddata.filter((e) => {
        const quoted = e.vendorquotes.some(x => x.vendor_email_id === userEmail)
        const isRejected = e.rejected == 1 && (e.vendorquotes.some(q => q.vendor_email_id === localStorage.getItem('email'))) && e.indent_rejected_by_vendor != 1;
        const match1 = e.vendorquotes.find(quote => quote.vendor_email_id === localStorage.getItem('email') && quote.vendor_rejected == 1)

        let isVendorMatch = false;
        if (e.vendorquotes && Array.isArray(e.vendorquotes)) {
          const vendorquote = e.vendorquotes.find((quote) => {
            return (
              quote.vendor_email_id === localStorage.getItem('email') &&
              quote.bid_winner === 0 &&
              quote.pending_vendor_approval != 1 &&
              e.approvedwithapproval2 == 1 &&
              e.accepted_vendor != localStorage.getItem('email')
            );
          });
          isVendorMatch = vendorquote !== undefined;
        }
        return ((isRejected || isVendorMatch || match1 || e.indentcancelledbyadmin == 1 || e.rejected == 1) && quoted) || e.rejected == 1
      });
      console.log(rejecteddata, 'rejecteddata')
    } else {
      rejecteddata = indentsdata.filter(e => e.rejected == 1 || e.rejectedwithapproval1 == 1 || e.indentcancelledbyadmin == 1);
    }

    let vendorrejecteddata = [];
    if (localStorage.getItem('user_type') === 'TRANSPORTER') {
      const userEmail = localStorage.getItem('email');
      const username = localStorage.getItem('username');
      let vendorRejecteddata = indentsdata.filter(e => e.indentcancelledbyadmin != 1)
      vendorrejecteddata = vendorRejecteddata.filter(e => {
        const q = e.vendorquotes || [];

        // true when this user is marked "declined" on the item
        const declinedByCurrentUser =
          e.vendors_participation &&
          e.vendors_participation.hasOwnProperty(username) &&
          e.vendors_participation[username] === 'declined';

        // ───── condition1: vendor rejected ─────
        const condition1 =
          (
            q.find(
              quote =>
                quote.vendor_email_id === userEmail &&
                quote.indent_rejected_by_vendor === 1
            ) &&
            e.validity_end !== 1 &&
            e.rejected != 1 &&
            e.vehicle_placement_expiried !== 1 &&
            e.rejectedwithapproval2 !== 1
          ) ||
          declinedByCurrentUser;

        // ───── condition2: previously accepted vendor ─────
        const condition2 =
          (
            e.previous_accepted_vendor === userEmail &&
            e.validity_end !== 1 &&
            e.vehicle_placement_expiried !== 1 &&
            e.rejectedwithapproval2 !== 1
          ) ||
          declinedByCurrentUser;
        const condition3
          =
          (
            q.some(qi => qi.vendor_email_id != userEmail) && e.indent_rejected_by_vendor == 1

          )
        const condition4 =
          (
            e.previous_accepted_vendor == localStorage.getItem('email')
          )
        return condition1 || condition2 || condition4
      });

    }
    else {
      vendorrejecteddata = indentsdata.filter(e => e.indent_rejected_by_vendor == 1 && e.rejected != 1 && e.indentcancelledbyadmin != 1);
    }

    const cancelleddata = indentsdata.filter(e => e.indentcancelledbyadmin == 1);
    const draftdata = draftData;

    if (localStorage.getItem('user_type') === 'TRANSPORTER') {
      totaldata = [...expireddata, ...awardeddata, ...activedata, ...vendorrejecteddata, ...rejecteddata];
    } else {
      totaldata = [...expireddata, ...awardeddata, ...activedata, ...vendorrejecteddata, ...rejecteddata, ...draftdata];
    }

    this.setState({
      countersfortab: {
        totalcount: totaldata.length,
        activecount: activedata.length,
        awardcount: awardeddata.length,
        vendorrejectedcount: vendorrejecteddata.length,
        vehicleplacementmissedcount: cancelleddata.length,
        draftscount: draftdata.length,
        rejectedcount: rejecteddata.length,
        expiredcount: expireddata.length,
        deliveredcount: 0
      }
    });
  };
  getOptionsLabel = (optionsArray, value) => {
    const match = optionsArray.find(opt => opt.value === value);
    return match ? match.label : value;
  };

  getdraftdata = () => {
    // Placeholder
  };

  cancelindent = (indent, bid) => {
    this.setState({ cancelIndentModel: true, paramsforrejection: { indent, bid } });
  };
  onClickviewRFQ = async function (e) {
    let destination_info = e.data.indent
    const destinationDetails = JSON.parse(destination_info.destination || '[]');
    this.setState({
      isPreviewMode: true,
      rfqForm: e.data.indent,
      dealers: destinationDetails
    });
  };
  onClickComments = async function (e) {
    let indent = e.data.indent;

    const fields = [
      { label: 'Additional Comments', value: indent && indent.additional_comments },
    ];

    const comment = fields
      .filter(field => field.value)
      .map(field => field.label + ': ' + field.value)
      .join('\n');

    this.setState({
      modelForAdditionalComments: true,
      additionalComments: comment || 'No comments provided'
    });
  };

  onClickmaterialdetails = async (params) => {
    if (params != 0) {
      await this.setState({
        detailCellRendererParams: {
          detailGridOptions: {
            columnDefs: [
              { headerName: "Dealer Code", field: "dealer_code", width: 150 },
              { headerName: "Dealer Name", field: "dealer_name", width: 200 },
              { headerName: "Dealer City", field: "dealer_city", width: 130 },
              { headerName: "Dealer State", field: "dealer_state", width: 160 },
              { headerName: "Dealer Pincode", field: "dealer_pincode", width: 130 },
              {
                headerName: "Material Type",
                field: "material_type",
                width: 180,
              },
              {
                headerName: "Dimensions(L x B x H)",
                valueGetter: function (params) {
                  var m = params.data;
                  const unit = m.material_units ? `(${m.material_units})` : '';
                  return `${m.material_length} x ${m.material_breath} x ${m.material_height} ${unit}`;
                },
                width: 200,
              }
              ,
              {
                headerName: "Quantity",
                field: "quantity",
                width: 100,
              },
              {
                headerName: "Prerequisite",
                field: "basic_requirment",
                width: 180,
              }
            ]
          },

          getDetailRowData: function (params) {
            var indent = params && params.data && params.data.indent;
            var destinationRaw = indent && indent.destination;
            var rowData = [];

            try {
              var destinations = JSON.parse(destinationRaw);

              destinations.forEach(function (dest) {
                dest.materials.forEach(function (material) {
                  rowData.push(Object.assign({}, dest, material));
                });
              });
            } catch (err) {
            }
            params.successCallback(rowData);
          }.bind(this),

          masterDetail: true
        }
      });


    }
    if (params.column.colDef.field == 'materials') {
      params.node.setExpanded(!params.node.expanded);
    }
    else {

      params.node.setExpanded(false);
    }
  }

  onClickallcomments = async (params) => {
    if (params !== 0) {
      await this.setState({
        detailCellRendererParams: {
          detailGridOptions: {
            columnDefs: [
              {
                headerName: "Indent ID",
                field: "indent_id",
                width: 120,
                resizable: true,

              },
              {
                headerName: "Action",
                field: "action",
                width: 300,
                resizable: true,

              },
              {
                headerName: "Action By",
                field: "action_by",
                resizable: true,


              },
              {
                headerName: "Action Date & Time",
                field: "action_time",
                resizable: true,

                valueFormatter: function (params) {
                  if (!params.value) return '';
                  return getHyphenDDMMYYYYHHMM(params.value)
                },
                cellStyle: { textTransform: 'capitalize' }
              },
              {
                headerName: "Remarks",
                field: "remarks",
                width: 200,
                resizable: true,

              },
            ]
          },
          getDetailRowData: function (gridParams) {
            var indent = gridParams && gridParams.data && gridParams.data.indent;
            if (!indent) {
              gridParams.successCallback([]);
              return;
            }

            var requestParams = { indent_id: indent.indent_id };

            redirectURL.post('/consignments/getallactionlogs', requestParams)
              .then(function (response) {
                if (response.data && Array.isArray(response.data)) {
                  let data = response.data;
                  let email = localStorage.getItem("email")
                  let created_by = indent.created_by
                  if (localStorage.getItem('user_type') === 'TRANSPORTER') {
                    data = data.filter(e =>
                      e.action_by === email ||
                      (![email, created_by].includes(e.action_by) && !indent.vendors.includes(e.action_by)) ||
                      (e.action_by === created_by && e.action_with && e.action_with == localStorage.getItem('email')) ||
                      e.action_by === created_by && !e.action_with
                    );
                  }

                  // Sort data by latest action_time first
                  data.sort((a, b) => new Date(b.action_time) - new Date(a.action_time));

                  // Remove Duplicate Actions (unique by 'action' text)
                  // const uniqueActionsMap = new Map();
                  // const uniqueData = [];

                  // data.forEach(item => {
                  //   if (!uniqueActionsMap.has(item.action)) {
                  //     uniqueActionsMap.set(item.action, true);
                  //     uniqueData.push(item);
                  //   }
                  // });
                  const uniqueActionsMap = new Map();
                  const uniqueData = [];

                  data.forEach(item => {
                    const key = item.action + "_" + item.action_by; // combine action & action_by
                    if (!uniqueActionsMap.has(key)) {
                      uniqueActionsMap.set(key, true);
                      uniqueData.push(item);
                    }
                  });


                  gridParams.successCallback(uniqueData);
                } else {
                  gridParams.successCallback([]);
                }
              })
              .catch(function (error) {
                console.error('Failed to fetch action logs:', error);
                gridParams.successCallback([]);
              });
          },

          masterDetail: true
        }
      });
    }
    if (params.column && params.column.colDef && params.column.colDef.field === 'allcomments') {
      params.node.setExpanded(!params.node.expanded);
    } else {
      params.node.setExpanded(false);
    }
  };

  onClickshowparticipants = async (params) => {
    if (params != 0) {

      await this.setState({

        detailCellRendererParams: {
          detailGridOptions: {

            columnDefs: [
              {
                headerName: "Vendor Name",
                field: "vendor",
                width: 160,
                cellRenderer: "Actionsforvendorcomponent",
                filter: false,
              },
              {
                headerName: "Participation Status",
                field: "status",
                filter: false,
                valueFormatter: params => {
                  const status = (params.value || "").toLowerCase();
                  if (status === "accepted") return "Accepted";
                  if (status === "declined") return "Declined";
                  if (status === "not responded") return "Not Responded";
                  return params.value; // fallback
                },
                cellStyle: params => {
                  const status = (params.value || "").toLowerCase();
                  let color = 'black';

                  if (status === 'accepted') {
                    color = 'green';
                  } else if (status === 'declined') {
                    color = 'red';
                  } else if (status === 'not responded') {
                    color = 'blue';
                  }

                  return {
                    color: color,
                    fontWeight: 'bold',
                    textTransform: 'capitalize'
                  };
                }
              }
              ,
              {
                headerName: "Remarks",
                field: "remarks",
              }


            ]
          },
          getDetailRowData: async function (params) {
            const indent = params && params.data && params.data.indent;
            const participation = indent.vendors_participation1 || {};
            const declinedReasons = indent.vendors_declined_reason1 || {};
            const vendorNamesArray = [];

            try {
              vendorNamesArray.push(...JSON.parse(indent.vendors_names));  // ["Jai Mata Logistics", "VRL Logistics", "NEGL"]
            } catch (e) {
            }
            for (const vendorName of vendorNamesArray) {
              if (!participation.hasOwnProperty(vendorName)) {
                participation[vendorName] = "No Response";
              }
            }
            const rowData = [];
            const addedVendors = new Set(); // Track already added vendor names

            for (const vendorName in participation) {
              const status = participation[vendorName];

              // Avoid duplicates
              const uniqueKey = vendorName.toLowerCase();
              if (addedVendors.has(uniqueKey)) continue;

              let remarks = "";
              if (status.toLowerCase() === "declined") {
                remarks = declinedReasons[vendorName] || "";
              }

              rowData.push({
                vendor: vendorName,
                status: status,
                remarks: remarks,
                indent_id: indent.indent_id,
                indent: indent
              });

              addedVendors.add(uniqueKey);
            }
            params.successCallback(rowData);
          }.bind(this),
          masterDetail: true
        }
      });
    }
    if (params.column.colDef.field == 'vendor_count') {
      params.node.setExpanded(!params.node.expanded);
    }
    else {
      params.node.setExpanded(false);
    }
  }
  onClickacceptparticipation = (params) => {
    let e = params.data
    redirectURL.post('/consignments/storeaccepflag', { 'indent_id': e.indent_id, 'vendor_name': localStorage.getItem('username'), 'vendor_email_id': localStorage.getItem('email') }).then((resp) => {
      this.setState({
        showsweetalert: true,
        basicType: 'success',
        basicTitle: 'Successfully Accepted',
        cancelIndentModel: false
      });
      this.resetindent()

    })
  }
  onClickdeclineparticipation = (params) => {
    this.setState({ declineModel: true, declinedata: params.data, declinereasonforvendor: "" });
  }
  onClickdeclineparticipation1 = (prop) => {
    prop.preventDefault()
    if (this.state.declinereasonforvendor != '' && this.state.declinereasonforvendor != undefined) {
      let e = this.state.declinedata
      redirectURL.post('/consignments/storedeclineflag', { declinereasonforvendor: this.state.declinereasonforvendor, 'indent_id': e.indent_id, 'vendor_name': localStorage.getItem('username'), 'email': localStorage.getItem('email') }).then((resp) => {
        this.setState({
          showsweetalert: true,
          basicType: 'success',
          basicTitle: `Indent ${e.indent_id} Successfully Declined`,
          declineModel: false,
          cancelIndentModel: false,
          declinereasonforvendor: ""
        });
        this.resetindent()
        emitDataReceived({ action: "Decline Indent" })
      })
    }
  }
  onClickbiddetails = async (params) => {
    let e = params.data
    this.setState({
      selected_for_placebid: e.indent_id
    })
    this.setState({
      overlay: 'show-m',
      showsliderforbid: true,
    });

    const { originalindents } = this.state;
    this.setState((prevState) => {
      const currentlyOpen = prevState.iscardOpen;
      if (currentlyOpen === e.indent_id) {
        return {
          iscardOpen: "",
          selectedindent: {},
        };
      } else {
        this.getbidhistory(e.indent_id);
        return {
          iscardOpen: e.indent_id,
          selectedindent: e,
        };
      }
    });
    const data = originalindents.filter((f) => f.indent_id === e.indent_id);
    let destinations = [];
    let data1 = JSON.parse(data[0].destination);

    data1.forEach((g) => {
      destinations.push({
        indent_id: e.indent_id,
        dealer_city: g.dealer_city,
        dealer_pincode: g.dealer_pincode,
        dealer_code: g.dealer_code,
        quantity: g.quantity,
      });
    });

    // Fetch stored data and update bid/transit days
    const paramsStored = {
      indent_id: e.indent_id,
      vendor_email_id: localStorage.getItem("email"),
    };

    redirectURL.post("/consignments/getstroreddata", paramsStored).then((resp) => {
      const transit_data = resp.data;

      transit_data.forEach((record) => {
        const match = destinations.find(
          (d) =>
            d.indent_id === record.indent_id &&
            d.dealer_city === record.dealer_city
        );
        if (match) {
          match.bid_price = record.bid_price;
          match.transit_days = record.transit_days;
        }
      });

      this.setState({
        indent_for_approve_for_bid: destinations,
        indent_for_approve_for_bid1: destinations,
      });
    });

    this.setState({
      inputTextValue: "",
      inputTextQuantity: "",
    });

    // Fetch LR data
    const paramsLR = { indent_id: e.indent_id };

    redirectURL.post("/consignments/getlr_data", paramsLR).then((resp) => {
      const data = resp.data;
      if (data && data !== "") {
        if (localStorage.getItem("roles") === "TRANSPORTER") {
          // If needed: filter by vendor_email_id
          // data = data.filter(f => f.vendor_email_id === localStorage.getItem("email"));
          this.setState({ lr_no_data: data });
        } else {
          this.setState({ lr_no_data: data });
        }
      }
    });

    // Fetch stored truck details
    redirectURL.post("/consignments/getstroreddata", paramsStored).then((resp) => {
      const data1 = resp.data;
      let destinations = [];

      data1.forEach((f) => {
        destinations.push({
          indent_id: e.indent_id,
          dealer_city: f.dealer_city,
          dealer_pincode: f.dealer_pincode,
          bid_price: f.bid_price,
          truck_no: f.truck_no,
          transit_days: f.transit_days,
          material: f.material,
        });
      });

      let indentfortruckdetails = [];
      data1.forEach((g) => {
        indentfortruckdetails.push({
          indent_id: e.indent_id,
          dealer_city: g.dealer_city,
          dealer_pincode: g.dealer_pincode,
          dealer_code: g.dealer_code,
          bid_price: g.bid_price,
          truck_no: g.truck_no,
          lr_no: g.lr_no,
        });
      });

      this.setState({
        indent_for_approve1: destinations,
        indentfortruckdetails: indentfortruckdetails,
      });
    });
  };
  gethistorydata = async (params) => {
    const indentId = params
    try {
      const response = await redirectURL.post("/consignments/getBidHistory", { indent_id: indentId });

      const bidHistory = Array.isArray(response.data.bid_history) ? response.data.bid_history : [];
      const negotiations = Array.isArray(response.data.negotiations) ? response.data.negotiations : [];
      const negotiationsLogs = Array.isArray(response.data.negotiationslogs) ? response.data.negotiationslogs : [];

      const originalIndent = this.state.originalindents.find(item => item.indent_id === indentId);

      this.setState({
        // overlay:'show-m',
        // showBidDetailsSlider: true, // ✅ this opens the slider
        selectedIndentData: originalIndent,
        selectedVendorQuotes: originalIndent && originalIndent.vendorquotes ? originalIndent.vendorquotes : [],
        bidHistory,
        negotiations,
        negotiationsLogs
      });

    } catch (error) {
      console.error("Error loading bid data:", error);
    }
  };
  closeConfirmationModal = () => {
    this.setState({ showConfirmationModal: false, confirmMessage: "", confirmActionCallback: null });
  };

  onClickentertruckdetails = async (params) => {
    const indent = params.data && params.data.indent;
    if (!indent) return;

    const indentId = indent.indent_id;

    try {
      const response = await redirectURL.post("/consignments/getBidHistory", { indent_id: indentId });

      const bidHistory = Array.isArray(response.data.bid_history) ? response.data.bid_history : [];
      const negotiations = Array.isArray(response.data.negotiations) ? response.data.negotiations : [];
      const negotiationsLogs = Array.isArray(response.data.negotiationslogs) ? response.data.negotiationslogs : [];

      const originalIndent = this.state.originalindents.find(item => item.indent_id === indentId);

      this.setState({
        overlay: 'show-m',
        // showBidDetailsSlider: true, // ✅ this opens the slider
        selectedIndentData: originalIndent,
        selectedVendorQuotes: originalIndent && originalIndent.vendorquotes ? originalIndent.vendorquotes : [],
        bidHistory,
        negotiations,
        negotiationsLogs,
        selectedindentdata1: params.data
      });
      //   this.onClickbiddetails()

      let e = params.data

      const { originalindents } = this.state;

      // Set selected indent and fetch bid history
      this.setState((prevState) => {
        const currentlyOpen = prevState.iscardOpen;
        if (currentlyOpen === e.indent_id) {
          return {
            iscardOpen: "",
            selectedindent: {},
          };
        } else {
          this.getbidhistory(e.indent_id);
          return {
            iscardOpen: e.indent_id,
            selectedindent: e,
          };
        }
      });

      // Filter original indent and prepare destinations
      const data = originalindents.filter((f) => f.indent_id === e.indent_id);
      let destinations = [];
      let data1 = JSON.parse(data[0].destination);

      data1.forEach((g) => {
        destinations.push({
          indent_id: e.indent_id,
          dealer_city: g.dealer_city,
          dealer_pincode: g.dealer_pincode,
          dealer_code: g.dealer_code,
          quantity: g.quantity,
        });
      });

      // Fetch stored data and update bid/transit days
      const paramsStored = {
        indent_id: e.indent_id,
        vendor_email_id: localStorage.getItem("email"),
      };

      redirectURL.post("/consignments/getstroreddata", paramsStored).then((resp) => {
        const transit_data = resp.data;

        transit_data.forEach((record) => {
          const match = destinations.find(
            (d) =>
              d.indent_id === record.indent_id &&
              d.dealer_city === record.dealer_city
          );
          if (match) {
            match.bid_price = record.bid_price;
            match.transit_days = record.transit_days;
          }
        });

        this.setState({
          indent_for_approve_for_bid: destinations,
          indent_for_approve_for_bid1: destinations,
        });
      });

      this.setState({
        inputTextValue: "",
        inputTextQuantity: "",
      });

      // Fetch LR data
      const paramsLR = { indent_id: e.indent_id };

      redirectURL.post("/consignments/getlr_data", paramsLR).then((resp) => {
        const data = resp.data;
        if (data && data !== "") {
          if (localStorage.getItem("roles") === "TRANSPORTER") {
            // If needed: filter by vendor_email_id
            // data = data.filter(f => f.vendor_email_id === localStorage.getItem("email"));
            this.setState({ lr_no_data: data });
          } else {
            this.setState({ lr_no_data: data });
          }
        }
      })
      var params = {
        "indent_id": e.indent_id
      }
      redirectURL.post('/consignments/getadminbifurdata', params).then((resp) => {
        const bifurdata = []
        var records = resp.data
        records.forEach((g) => {
          bifurdata.push({
            "indent_id": e.indent_id,
            "dealer_city": g.dealer_city,
            "dealer_state": g.dealer_state,
            'dealer_pincode': g.dealer_pincode,
            "dealer_name": g.dealer_name,
            "dealer_code": g.dealer_code,
            "bid_price": g.bid_price,
            "quantity": g.quantity,

          })
        })

        this.setState({
          dataforadminbifur: bifurdata,
          indentfortruckdetails: bifurdata
        }, () => {
          // This will execute after state is updated
          this.setState({
            showBidDetailsSlider1: true // Open Modal AFTER data is ready
          });
        });
      })
    }
    catch (error) {
    }
  };
  onClickshowbiddata = async (params) => {
    const indent = params.data && params.data.indent;
    if (!indent) return;

    const indentId = indent.indent_id;

    try {
      const response = await redirectURL.post("/consignments/getBidHistory", { indent_id: indentId });

      const bidHistory = Array.isArray(response.data.bid_history) ? response.data.bid_history : [];
      const negotiations = Array.isArray(response.data.negotiations) ? response.data.negotiations : [];
      const negotiationsLogs = Array.isArray(response.data.negotiationslogs) ? response.data.negotiationslogs : [];

      const originalIndent = this.state.originalindents.find(item => item.indent_id === indentId);

      this.setState({
        overlay: 'show-m',
        // showBidDetailsSlider: true, // ✅ this opens the slider
        selectedIndentData: originalIndent,
        selectedVendorQuotes: originalIndent && originalIndent.vendorquotes ? originalIndent.vendorquotes : [],
        bidHistory,
        negotiations,
        negotiationsLogs,
        selectedindentdata1: params.data
      });
      //   this.onClickbiddetails()

      let e = params.data

      const { originalindents } = this.state;

      // Set selected indent and fetch bid history
      this.setState((prevState) => {
        const currentlyOpen = prevState.iscardOpen;
        if (currentlyOpen === e.indent_id) {
          return {
            iscardOpen: "",
            selectedindent: {},
          };
        } else {
          this.getbidhistory(e.indent_id);
          return {
            iscardOpen: e.indent_id,
            selectedindent: e,
          };
        }
      });

      // Filter original indent and prepare destinations
      const data = originalindents.filter((f) => f.indent_id === e.indent_id);
      let destinations = [];
      let data1 = JSON.parse(data[0].destination);

      data1.forEach((g) => {
        destinations.push({
          indent_id: e.indent_id,
          dealer_city: g.dealer_city,
          dealer_pincode: g.dealer_pincode,
          dealer_code: g.dealer_code,
          quantity: g.quantity,
        });
      });

      // Fetch stored data and update bid/transit days
      const paramsStored = {
        indent_id: e.indent_id,
        vendor_email_id: localStorage.getItem("email"),
      };

      redirectURL.post("/consignments/getstroreddata", paramsStored).then((resp) => {
        const transit_data = resp.data;

        transit_data.forEach((record) => {
          const match = destinations.find(
            (d) =>
              d.indent_id === record.indent_id &&
              d.dealer_city === record.dealer_city
          );
          if (match) {
            match.bid_price = record.bid_price;
            match.transit_days = record.transit_days;
          }
        });

        this.setState({
          indent_for_approve_for_bid: destinations,
          indent_for_approve_for_bid1: destinations,
        });
      });

      this.setState({
        inputTextValue: "",
        inputTextQuantity: "",
      });

      // Fetch LR data
      const paramsLR = { indent_id: e.indent_id };

      redirectURL.post("/consignments/getlr_data", paramsLR).then((resp) => {
        const data = resp.data;
        if (data && data !== "") {
          if (localStorage.getItem("roles") === "TRANSPORTER") {
            // If needed: filter by vendor_email_id
            // data = data.filter(f => f.vendor_email_id === localStorage.getItem("email"));
            this.setState({ lr_no_data: data });
          } else {
            this.setState({ lr_no_data: data });
          }
        }
      });
      var params = {
        "indent_id": e.indent_id
      }
      redirectURL.post('/consignments/getadminbifurdata', params).then((resp) => {
        const bifurdata = []
        var records = resp.data
        records.forEach((g) => {
          bifurdata.push({
            "indent_id": e.indent_id,
            "dealer_city": g.dealer_city,
            "dealer_state": g.dealer_state,
            'dealer_pincode': g.dealer_pincode,
            "dealer_name": g.dealer_name,
            "dealer_code": g.dealer_code,
            "bid_price": g.bid_price,
            "quantity": g.quantity,

          })
        })

        this.setState({
          dataforadminbifur: bifurdata,
          indentfortruckdetails: bifurdata
        }, () => {
          // This will execute after state is updated
          this.setState({
            bidDetailsform: true,
            // showBidDetailsSlider: true // Open Modal AFTER data is ready
          });
        });
      })
    }
    catch (error) {
      console.error("Error loading bid data:", error);
    }
  };

  onclickreject = (e) => {
    e.preventDefault()
    if (this.state.rejectionReasonbyapproval1 != '' && this.state.rejectionReasonbyapproval1 != undefined) {
      const params = { ...this.state.paramsforrejection };
      params.rejected_reason_by_approval1 = this.state.rejectionReasonbyapproval1;
      redirectURL.post('/consignments/cancelindentbyapproval1', params).then((resp) => {
        this.setState({
          showsweetalert: true,
          basicType: 'success',
          basicTitle: `Indent ${params.indent.indent_id} has been rejected successfully`,
          cancelIndentModel: false,
          showBidDetailsSlider: false,
          rejectionReasonbyapproval1: ''
        });
        this.resetindent();
        emitDataReceived({ action: "Cancel Indent by Admin" })
      });
    }

  };

  fetchInitialData = () => {
    this.setState({ loadshow: "show-m" });
    const userType = localStorage.getItem('user_type');
    const userEmail = localStorage.getItem('email');
    const { selectedfromdate, selectedenddate } = this.state;
    const params = {
      user_type: localStorage.getItem("user_type"),
      email: localStorage.getItem("email"),
      from_date: selectedfromdate,
      to_date: selectedenddate
    };

    redirectURL.post("/consignments/fetchRFQsForDashboard", params).then((response) => {
      const record = response.data || [];
      const data = record.filter(e => e.is_draft !== 1);
      const draftData = record.filter(e => e.is_draft === 1);
      let userEmail = localStorage.getItem('email')
      this.setState({
        draftdata: draftData,
        originalindents: data,
        alldata: data,
        indentsdata: data
      });

      this.getcountersforindents(data, draftData);

      let filterData = data;
      const rfqform = this.state.rfqform;

      if (rfqform.active === 'activet1') {

        if (userType === 'TRANSPORTER') {
          filterData = filterData.filter(e => {
            const hasValidVendorDetails = e.vendordetails && e.vendordetails.length > 0 && e.indent_assigned !== 1 && e.validity_end !== 1 && e.rejected !== 1;
            const hasPendingDifferentVendor = e.indent_pending_data && e.indent_pending_data.vendor_email_id !== userEmail;
            const hasPreviousDifferentVendorAndMatchingQuote = e.previous_accepted_vendor !== userEmail && e.vendorquotes && e.vendorquotes.some(f => f.vendor_email_id === userEmail) && e.vendorquotes.find(g => g.bid_winner !== 1);
            const isExpiredWithNoQuote = this.isBiddingWindowExpired(e.bidding_window, e.create_date) && (!e.vendorquotes || !e.vendorquotes.some(q => q.vendor_email_id === userEmail));

            return (hasValidVendorDetails || hasPendingDifferentVendor || hasPreviousDifferentVendorAndMatchingQuote) && !isExpiredWithNoQuote;
          });

          filterData = filterData.filter(e =>
            e.previous_accepted_vendor !== userEmail &&
            e.indentcancelledbyadmin !== 1 &&
            e.indent_cancelled !== 1 &&
            e.approvedwithapproval2 !== 1 &&
            e.rejected !== 1
          );

          filterData = filterData.filter(e => {
            const vendorquotes = e.vendorquotes || [];
            if (vendorquotes.length > 0 && vendorquotes.some(quote => quote.vendor_email_id === userEmail)) {
              const vendorquote = vendorquotes.find(quote =>
                quote.vendor_email_id === userEmail &&
                quote.vendor_rejected !== 1 &&
                quote.indent_rejected_by_vendor !== 1 &&
                quote.indent_accepted_by_vendor !== 1 &&
                e.approvedwithapproval2 !== 1 &&
                e.validity_end !== 1
              );
              return vendorquote !== undefined;
            }
            return true;
          });
        } else {
          filterData = filterData.filter(e => e.vendordetails && e.vendordetails.length > 0 && e.indent_assigned !== 1 && e.validity_end !== 1 && e.rejected !== 1 && e.indentcancelledbyadmin !== 1 || (
            e.vendorquotes.length > 0 ||
            !this.isBiddingWindowExpired(e.bidding_window, e.create_date)
          ));


        }
      }
      else if (rfqform.drafts == 'activet1') {
        filterData = draftData
      }
      else if (rfqform.awarded == 'activet1') {
        if (userType === 'TRANSPORTER') {
          filterData = filterData.filter(item =>
            item.accepted_vendor === userEmail &&
            item.vehicle_placement_expiried !== 1 &&
            item.rejected !== 1 &&
            item.validity_end !== 1
          ).filter(item => {
            const q = item.vendorquotes || [];
            const vendorquote = q.find(quote =>
              (quote.vendor_email_id === userEmail &&
                quote.indent_rejected_by_vendor !== 1 &&
                quote.indent_accepted_by_vendor === 1) ||
              quote.bid_winner === 1
            );
            return vendorquote !== undefined;
          });
        } else {
          filterData = filterData.filter(item =>
            item.indent_assigned === 1 &&
            item.indent_rejected_by_vendor !== 1 &&
            item.vehicle_placement_expiried !== 1 &&
            item.indent_cancelled !== 1 && item.rejected != 1
          );
        }
        filterData = filterData
      }
      else if (rfqform.vendorrejected == 'activet1') {
        if (userType === 'TRANSPORTER') {
          filterData = filterData.filter(item => {
            const q = item.vendorquotes || [];
            // current user
            const username = localStorage.getItem('username');

            // true when this user is marked "declined" on the item
            const declinedByCurrentUser =
              item.vendors_participation &&
              item.vendors_participation.hasOwnProperty(username) &&
              item.vendors_participation[username] === 'declined';

            /* ─────────────────────────  CONDITIONS  ───────────────────────── */

            const condition1 =
              (
                q.find(
                  quote =>
                    quote.vendor_email_id === userEmail &&
                    quote.indent_rejected_by_vendor === 1
                ) &&
                item.validity_end !== 1 &&
                item.vehicle_placement_expiried !== 1 &&
                item.rejectedwithapproval2 !== 1
              ) ||
              declinedByCurrentUser;

            const condition2 =
              (
                item.previous_accepted_vendor === userEmail &&
                item.validity_end !== 1 &&
                item.vehicle_placement_expiried !== 1 &&
                item.rejectedwithapproval2 !== 1
              ) ||
              declinedByCurrentUser;

            const condition3 =
              (
                q.some(qi => qi.vendor_email_id != userEmail) && item.indent_rejected_by_vendor == 1

              )
            const condition4 =
              (
                item.previous_accepted_vendor == localStorage.getItem('email')
              )
            return condition1 || condition2 || condition3 || condition4

          });
        } else {
          filterData = filterData.filter(item => item.indent_rejected_by_vendor === 1 && item.rejected != 1 && item.indentcancelledbyadmin !== 1);
        }
      }
      else if (rfqform.rejected == "activet1") {
        if (userType === 'TRANSPORTER') {
          filterData = filterData.filter(e => e.previous_accepted_vendor != localStorage.getItem('email') || e.rejected == 1)
          filterData = filterData.filter(item => {
            const q = item.vendorquotes || [];
            const isRejected = item.rejected === 1 && q.some(qi => qi.vendor_email_id === userEmail) && item.previous_accepted_vendor != localStorage.getItem('email')
            const match = q.find(quote => quote.vendor_email_id === userEmail && quote.bid_winner === 0 && quote.pending_vendor_approval == 1 && item.approvedwithapproval2 == 1
              && item.accepted_vendor !== userEmail)
            const match1 = q.find(quote => quote.vendor_email_id === userEmail && quote.vendor_rejected == 1)
            return isRejected || match !== undefined || match1 || item.indentcancelledbyadmin == 1 || item.rejected == 1
          });
        } else {
          filterData = filterData.filter(item => item.rejected === 1 || item.rejectedwithapproval1 === 1);
        }
      }

      else if (rfqform.completed == "activet1") {
    if (localStorage.getItem('rfq_role') == 'ADMIN') {
          filterData = filterData.filter(e => e.rejected != 1 && e.indent_assigned != 1 && e.approved_changed_l2_as_l1 != 1)
          filterData = filterData.filter(
            item =>
              (this.isBiddingWindowExpired(item.bidding_window, item.create_date) && item.rejected != 1 &&
                item.vendorquotes.length === 0) || (item.validity_end === 1 || item.vehicle_placement_expiried === 1)
          );
        }
        else {
          const username = localStorage.getItem('username');
          const userEmail = localStorage.getItem('email');

          filterData = filterData.filter(item => {
            const vendorQuotes = item.vendorquotes || [];

            const isExpired =
              item.validity_end === 1 ||
              item.vehicle_placement_expiried === 1 ||
              this.isBiddingWindowExpired(item.bidding_window, item.create_date);

            const notQuoted = !vendorQuotes.some(x => x.vendor_email_id === userEmail && x.negotiation_closed != 1);
            const userDeclined = item.vendors_participation &&
              item.vendors_participation.hasOwnProperty(username) &&
              item.vendors_participation[username] === "declined";
            const isBiddingExpired = this.isBiddingWindowExpired(item.bidding_window, item.create_date);

            const expitedvaliddata = isBiddingExpired &&
              !vendorQuotes.some(q => q.vendor_email_id === userEmail) &&
              !userDeclined && item.rejected != 1

            const declinedByCurrentUser =
              item.vendors_participation &&
              item.vendors_participation.hasOwnProperty(username) &&
              item.vendors_participation[username] === 'declined'
            return (isExpired) && !declinedByCurrentUser && item.rejected != 1 && item.indent_assigned != 1 && item.waiting_for_approval1 != 1 && item.approvedwithapproval2 != 1
          });

        }
      }
      this.setState({ allindents: filterData, loadshow: "show-n", overlay: 'show-n' });
      if (this.state.selectedTab === 'Active Indents') {
        this.onClickchildTab(this.state.selectedChildTab);
      }
    });
  };
  resetindent = async () => {
    await this.fetchInitialData();
    const { rfqform, originalindents, selectedindent } = this.state;
    let awardeddata = [];

    if (rfqform.awarded === 'activet1') {
      if (localStorage.getItem('user_type') === 'TRANSPORTER') {
        awardeddata = originalindents.filter(e => e.accepted_vendor === localStorage.getItem('email') && e.vehicle_placement_expiried != 1 && e.rejected != 1);
        awardeddata = awardeddata.filter(e => {
          if (e.vendorquotes && Array.isArray(e.vendorquotes)) {
            const vendorquote = e.vendorquotes.find(quote =>
              quote.vendor_email_id === localStorage.getItem('email') &&
              quote.indent_rejected_by_vendor != 1 &&
              quote.indent_accepted_by_vendor === 1
            );
            return vendorquote !== undefined;
          }
          return false;
        });
      } else {
        awardeddata = originalindents.filter(e => e.indent_assigned == 1 && e.indent_rejected_by_vendor != 1 && e.vehicle_placement_expiried != 1 && e.indent_cancelled != 1);
      }
      this.setState({ loadshow: 'show-n', allindents: awardeddata, overlay: 'show-n' });
    }

    if (selectedindent.indent_id) {
      this.getbidhistory(selectedindent.indent_id);
      this.gethistorydata(selectedindent.indent_id)
      const params = { indent_id: selectedindent.indent_id };
      redirectURL.post('/consignments/getlr_data', params).then(resp => {
        if (resp && resp.data) {
          const data = resp.data;
          if (data !== '') {
            this.setState({ lr_no_data: data });
          }
        }
      });
    }
  };

  refreshindent = async () => {
    const today = moment().format('YYYY-MM-DD');
    const oneWeekAgo = moment().subtract(30, 'days').format('YYYY-MM-DD');

    // First, set the date values in state
    await this.setState({
      selectedfromdate: oneWeekAgo,
      selectedenddate: today
    });

    // Then fetch the data (this will use updated dates)
    await this.fetchInitialData();

    const { rfqform, originalindents, selectedindent, selectedfromdate, selectedenddate } = this.state;
    let awardeddata = [];

    if (rfqform.awarded === 'activet1') {
      if (localStorage.getItem('user_type') === 'TRANSPORTER') {
        awardeddata = originalindents.filter(e =>
          e.accepted_vendor === localStorage.getItem('email') &&
          e.vehicle_placement_expiried != 1 &&
          e.rejected != 1
        );
        awardeddata = awardeddata.filter(e => {
          if (e.vendorquotes && Array.isArray(e.vendorquotes)) {
            const vendorquote = e.vendorquotes.find(quote =>
              quote.vendor_email_id === localStorage.getItem('email') &&
              quote.indent_rejected_by_vendor != 1 &&
              quote.indent_accepted_by_vendor === 1
            );
            return vendorquote !== undefined;
          }
          return false;
        });
      } else {
        awardeddata = originalindents.filter(e =>
          e.indent_assigned == 1 &&
          e.indent_rejected_by_vendor != 1 &&
          e.vehicle_placement_expiried != 1 &&
          e.indent_cancelled != 1
        );
      }
      this.setState({ loadshow: 'show-n', allindents: awardeddata });
    }

    // Use selectedfromdate and selectedenddate here
    const params = {
      user_type: localStorage.getItem("user_type"),
      email: localStorage.getItem("email"),
      from_date: selectedfromdate,
      to_date: selectedenddate
    };

    if (selectedindent.indent_id) {
      this.getbidhistory(selectedindent.indent_id);
      const lrParams = { indent_id: selectedindent.indent_id };
      redirectURL.post('/consignments/getlr_data', lrParams).then(resp => {
        if (resp && resp.data && resp.data !== '') {
          this.setState({ lr_no_data: resp.data });
        }
      });
    }
  };

  acceptindentbyvendor = (indent) => {
    const params = {
      indent_id: indent.indent_id,
      accepted_vendor: indent.accepted_vendor
    };
    redirectURL.post('/consignments/acceptindentbyvendor', params).then((resp) => {
      this.setState({
        showsweetalert: true,
        basicType: 'success',
        basicTitle: `Indent ${indent.indent_id} is successfully accepted`,
        showBidDetailsSlider: false
      });
      this.resetindent();
    });
  };
  rejectindentbyvendor = (indent) => {
    this.setState({
      rejectModel: true,
      selectedindentforvendor: indent
    });
  };

  onSubmitdataforrejection = () => {
    if (this.state.rejectionReasonbyvendor != '' && this.state.rejectionReasonbyvendor != undefined) {
      const { selectedindentforvendor, rejectionReasonbyvendor } = this.state;
      const params = {
        indent_id: selectedindentforvendor.indent_id,
        accepted_vendor: selectedindentforvendor.accepted_vendor,
        rejectionreason: rejectionReasonbyvendor,
        rejectedreason_vendorname: localStorage.getItem('firstname'),
        email: localStorage.getItem('email')
      };

      redirectURL.post('/consignments/rejectindentbyvendor', params).then((resp) => {
        this.setState({
          showsweetalert: true,
          basicType: 'success',
          basicTitle: 'You have successfully rejected the indent.',
          rejectModel: false,
          showBidDetailsSlider: false
        });
        this.resetindent();
      });
    }
  };

  getbidhistory = async (indent_id) => {
    await redirectURL.post("/consignments/getBidHistory", { indent_id }).then(response => {
      this.setState({
        bidHistory: response.data.bid_history,
        negotiations: response.data.negotiations,
        negotiationsHistory: response.data.negotiationslogs
      });
    });
  };

  isBiddingWindowExpired = (biddingWindow, createDate) => {
    if (!biddingWindow || !biddingWindow.includes(':') || !createDate) {
      return true;
    }

    const [hours, minutes] = biddingWindow.split(':').map(Number);
    if (isNaN(hours) || isNaN(minutes)) {
      return true;
    }

    const localCreateDate = new Date(createDate.replace('Z', '') + '+05:30');
    const biddingEndTime = new Date(localCreateDate);

    biddingEndTime.setHours(biddingEndTime.getHours() + hours);
    biddingEndTime.setMinutes(biddingEndTime.getMinutes() + minutes);

    const currentTime = new Date();


    return currentTime > biddingEndTime;
  };

  deletedraftindent = (e) => {
    let draft_id = e.data.indent_id
    if (window.confirm(`Are you sure you want to delete draft?`)) {
      const params = { 'draft_id': draft_id };
      redirectURL.post('/consignments/deletedraftindent', params).then((resp) => {
        this.setState({
          showsweetalert: true,
          basicType: 'success',
          basicTitle: `Draft has been deleted`
        });
        this.resetindent();
      }).catch((err) => {
        this.setState({
          showsweetalert: true,
          basicType: 'error',
          basicTitle: 'Failed to delete draft'
        });
      });
    }
  };
  onClickBidNow = async (e) => {
    const { originalindents } = this.state;

    this.setState(prevState => {
      if (prevState.isCardOpen === e.indent_id) {
        return { isCardOpen: '', selectedindent: {} };
      } else {
        this.getbidhistory(e.indent_id);
        return { isCardOpen: e.indent_id, selectedindent: e };
      }
    });

    const data = originalindents.filter(f => f.indent_id === e.indent_id);
    let destinations = [];
    let data1 = JSON.parse(data[0].destination);
    data1.forEach(g => {
      destinations.push({
        indent_id: e.indent_id,
        dealer_city: g.dealer_city,
        dealer_pincode: g.dealer_pincode,
        dealer_code: g.dealer_code,
        quantity: g.quantity
      });
    });

    const params1 = {
      indent_id: e.indent_id,
      vendor_email_id: localStorage.getItem('email')
    };

    redirectURL.post('/consignments/getstroreddata', params1).then(resp => {
      const transit_data = resp.data;
      transit_data.forEach(transitRecord => {
        const destinationRecord = destinations.find(dest =>
          dest.indent_id === transitRecord.indent_id &&
          dest.dealer_city === transitRecord.dealer_city
        );
        if (destinationRecord) {
          destinationRecord.bid_price = transitRecord.bid_price;
          destinationRecord.transit_days = transitRecord.transit_days;
        }
      });

      this.setState({
        indent_for_approve_for_bid: destinations,
        indent_for_approve_for_bid1: destinations,
        inputTextValue: "",
        inputTextQuantity: ""
      });
    });

    const params2 = { indent_id: e.indent_id };
    redirectURL.post('/consignments/getlr_data', params2).then(resp => {
      const data = resp.data;
      if (data && data !== '') {
        this.setState({ lr_no_data: data });
      }
    });

    const params3 = {
      indent_id: e.indent_id,
      vendor_email_id: localStorage.getItem('email')
    };
    redirectURL.post('/consignments/getstroreddata', params3).then(resp => {
      const data1 = resp.data;
      let destinations = [];
      data1.forEach(f => {
        destinations.push({
          indent_id: e.indent_id,
          dealer_city: f.dealer_city,
          dealer_pincode: f.dealer_pincode,
          truck_no: f.truck_no,
          bid_price: f.bid_price,

          transit_days: f.transit_days,
          material: f.material
        });
      });
      this.setState({ indent_for_approve1: destinations });

      let indentfortruckdetails = [];
      data1.forEach(g => {
        indentfortruckdetails.push({
          indent_id: e.indent_id,
          dealer_city: g.dealer_city,
          dealer_pincode: g.dealer_pincode,
          dealer_code: g.dealer_code,
          truck_no: g.truck_no,
          lr_no: g.lr_no
        });
      });
      this.setState({ indentfortruckdetails });
    });
  };
  onClickHideall = () => {
    this.setState({
      loadshow: 'show-n',
      overlay: 'show-n',
      showBidDetailsSlider: false,
      showBidDetailsSlider1: false,

      modelForNotifications: false,
      showsliderforbid: false
    });
  };
  onClickAcceptNegotiation = (indent_id, bid_price, no_of_deliveries, vendor_email_id, indent_created_by) => {
    const params = {
      indent_id,
      bid_price,
      no_of_deliveries,
      vendor_email_id,
      email: localStorage.getItem("email"),
      user_type: localStorage.getItem("user_type"),
      indent_created_by
    };

    redirectURL.post("/consignments/acceptNegotiationValue", params).then(response => {
      const isSuccess = response.data.status === "success";
      this.setState({
        showsweetalert: true,
        basicType: isSuccess ? "success" : "danger",
        basicTitle: 'Negotiated value has been accepted successfully.'
      });

      if (isSuccess) {
        this.setState({
          isVendorInputOpen: "",
          isProposedInputOpen: "",
          showBidDetailsSlider: false
        });
        this.resetindent();

      }
    }).catch(error => {
      this.setState({
        showsweetalert: true,
        basicType: "danger",
        basicTitle: "An error occurred while processing the request."
      });
    });
  };
  onCloseSlider = () => {
    this.setState({
      overlay: 'show-n',
      showsliderforbid: false,
      showBidDetailsSlider1: false,

    })
  }
  onCancel = (e) => {
    this.setState({
      showBidDetailsSlider1: false,
      overlay: 'show-n'
    })
  }

  onSubmitdataforadminbifurcation = () => {
    const { dataforadminbifur, adminbifurComment } = this.state;

    // Step 1: Validate comment
    if (!adminbifurComment || adminbifurComment.trim() === '') {
      this.setState({
        showsweetalert: true,
        basicType: "danger",
        basicTitle: "Comment is required before submission."
      });
      return;
    }

    // Step 2: Validate price match
    const negotiatedconfirmed_price = dataforadminbifur[0].negotiatedconfirmed_price;
    const totalBidPrice = dataforadminbifur.reduce((sum, item) => {
      return sum + (parseFloat(item.bid_price) || 0);
    }, 0);

    if (totalBidPrice === negotiatedconfirmed_price) {
      const params1 = {
        indent_id: dataforadminbifur[0].indent_id,
        bid_price: negotiatedconfirmed_price,
        vendor_email_id: dataforadminbifur[0].vendor_email_id,
        email: localStorage.getItem("email"),
        user_type: localStorage.getItem("user_type"),
        indent_created_by: dataforadminbifur[0].indent_created_by,
        adminbifurComment: adminbifurComment
      };

      redirectURL.post("/consignments/AcceptQuotationwithadmin", params1).then(response => {
        const isSuccess = response.data.status === "success";
        if (isSuccess) {
          this.setState({
            isVendorInputOpen: "",
            isProposedInputOpen: "",
            showBidDetailsSlider: false,
            adminbifurComment: ''
          });
        }
      }).catch(error => {
        console.log(error);
        this.setState({
          showsweetalert: true,
          basicType: "danger",
          basicTitle: "An error occurred while processing the request."
        });
      });

      redirectURL.post('/consignments/storeadminbifur', dataforadminbifur).then(resp => {
        this.setState({
          showsweetalert: true,
          basicType: "success",
          basicTitle: 'Vendor value has been accepted successfully',
          cardforadminbifurcation: false,
          showBidDetailsSlider: false,
          overlay: 'show-n',
          adminbifurComment: ''
        });
        this.resetindent();
      });
    } else {
      this.setState({
        showsweetalert: true,
        basicType: "danger",
        basicTitle: "Bifurcation bid price must equal bid price"
      });
    }
  };
  onCloseModal = () => {
    this.setState({
      modelForAdditionalComments: false,
      modelForShowBids: false,
      modelForNotifications: false,
      modelForEditAssigned: false,
      vehicleDetailsModel: false,
      cardforadminbifurcation: false,
      adminbifurComment: '',
      cancelIndentModel: false,
      rejectModel: false,
      declineModel: false,
      modelForNotifications: false,
      overly: 'show-n',
      overlay: 'show-n',
      rejectionReasonbyapproval1: ''
    });
  };
  getIndentStatus = (indent) => {
    const userEmail = localStorage.getItem("email");
    const username = localStorage.getItem("username");
    const userRole = localStorage.getItem("roles");
    const userType = localStorage.getItem("user_type");

    const vendorquotes = indent.vendorquotes || [];
    const userQuote = vendorquotes.find(q => q.vendor_email_id === userEmail);
    const hasQuoteFromUser = !!userQuote;

    const isBiddingExpired = this.isBiddingWindowExpired(indent.bidding_window, indent.create_date);
    const condition3 =
      (
        vendorquotes.some(qi => qi.vendor_email_id == userEmail && qi.indent_rejected_by_vendor == 1) && indent.indent_rejected_by_vendor == 1

      )
    const userDeclined = indent.vendors_participation &&
      indent.vendors_participation.hasOwnProperty(username) &&
      indent.vendors_participation[username] === "declined";

    // 1. Draft
    if (indent.is_draft === 1) return "Draft";
    if (indent.indentcancelledbyadmin === 1 && userQuote) return "Indent Rejected";
    if (
      (userQuote && userQuote.indent_rejected_by_vendor === 1) ||
      indent.previous_accepted_vendor === userEmail ||
      userDeclined || condition3
    ) {
      return "Vendor Declined";
    }
    // 2. Cancelled by admin
    if (((indent.indentcancelledbyadmin === 1 || indent.rejected == 1 || (userQuote && userQuote.vendor_rejected == 1)) && userQuote || indent.rejected == 1)) return "Indent Rejected";

    // 3. Rejected
    if (
      indent.rejected === 1 ||
      indent.rejectedwithapproval1 === 1 ||
      indent.rejectedwithapproval2 === 1
    ) {
      if (userType === "TRANSPORTER" && hasQuoteFromUser && indent.previous_accepted_vendor != userEmail) return "Indent Rejected";
    }

    // 4. Vendor Rejected


    if (
      indent &&
      userQuote &&
      indent.truck_details_completed !== 1 &&
      (userQuote.indent_accepted_by_vendor === 1 || userQuote.bid_winner === 1)
    ) {
      return 'Awaiting Truck Details';
    }

    // 5. Awarded
    if (
      indent.accepted_vendor === userEmail &&
      indent.vehicle_placement_expiried !== 1 &&
      indent.rejected !== 1 &&
      userQuote &&
      userQuote.indent_rejected_by_vendor !== 1 &&
      (userQuote.indent_accepted_by_vendor === 1 || userQuote.bid_winner === 1 && indent.truck_details_completed == 1)
    ) {
      return "Indent Awarded";
    }

    // 6. Awaiting Approval
    if (
      userQuote &&
      userQuote.negotiation_closed === 1 &&
      userQuote.bid_winner !== 1
    ) {
      return "Awaiting Approval";
    }
    if (
      indent.validity_end === 1 && indent.approved_changed_l2_as_l1 !== 1 ||
      indent.vehicle_placement_expiried === 1 ||
      (
        isBiddingExpired &&
        !vendorquotes.some(q => q.vendor_email_id === userEmail) &&
        !userDeclined &&
        indent.validity_end == 1 &&
        indent.indent_accepted_by_vendor !== 1 &&
        indent.approved_changed_l2_as_l1 !== 1
      ) || (!userQuote && isBiddingExpired)
    ) {
      return "Expired";
    }
    // 7. Negotiation In Progress
    if (
      (userQuote && userQuote.pending_vendor_approval === 1) ||
      indent.pending_vendor_approval === 1 ||
      (userQuote && userQuote.in_negotiation === 1)
    ) {
      return "Negotiation In Progress";
    }

    // 8. Expired
    if (
      indent.validity_end === 1 ||
      indent.vehicle_placement_expiried === 1 ||
      (
        isBiddingExpired &&
        !vendorquotes.some(q => q.vendor_email_id === userEmail) &&
        !userDeclined &&
        indent.validity_end !== 1 &&
        indent.vehicle_placement_expiried !== 1 && indent.indent_accepted_by_vendor != 1 &&
        indent.approved_changed_l2_as_l1 != 1
      )
    ) {
      return "Expired";
    }

    // 9. Bidding In Progress (default)
    return "Bidding In Progress";
  };
  fetchNotificationsData = (e) => {
    let indent_id = e.data.indent_id
    const params = {
      email: localStorage.getItem("email"),
      indent_id: indent_id
    };
    redirectURL.post("/consignments/fetchNotificationsData", params).then(response => {
      this.setState({
        notificationUnread: response.data.Unreadnotifications,
        notificationRead: response.data.Readnotifications,
        modelForNotifications: true,
        overlay: 'show-m',
        overly: 'show-m',
        selectedindentfornofication: indent_id
      });

      const { allindents } = this.state;
      const updatedIndents = allindents.map(indent => {
        if (indent.indent_id === indent_id) {
          return { ...indent, notification_count: 0 };
        }
        return indent;
      });

      this.setState({ allindents: updatedIndents });
    });
  };


  handlerStartDateTime = (event, currentDate, selectedDate) => {
    const d = new Date(event._d);
    const startdate = d.getFullYear() + "-" + ((d.getMonth() + 1) < 10 ? "0" + (d.getMonth() + 1) : (d.getMonth() + 1)) + "-" + (d.getDate() < 10 ? "0" + d.getDate() : d.getDate());
    this.setState({ selectedfromdate: startdate });
  };

  handlerEndDateTime = (event, currentDate, selectedDate) => {
    const d = new Date(event._d);
    const startdate = d.getFullYear() + "-" + ((d.getMonth() + 1) < 10 ? "0" + (d.getMonth() + 1) : (d.getMonth() + 1)) + "-" + (d.getDate() < 10 ? "0" + d.getDate() : d.getDate());
    this.setState({ selectedenddate: startdate });
  };

  handleSelectChange = (name, selectedOption) => {
    const { searchfilter } = this.state;
    this.setState({
      searchfilter: {
        ...searchfilter,
        [name]: selectedOption ? selectedOption.value : null
      }
    });
  };

  resetSearchFilter = () => {
    this.setState((prev) => ({ filterToggle: !prev.filterToggle }))
    const { rfqform, originalindents, alldata } = this.state;
    const updatedRfqForm = {
      ...rfqform,
      cancelled: '',
      total: 'activet1',
      active: '',
      completed: '',
      awarded: '',
      rejected: '',
      Delivered: '',
      vendorrejected: '',
      vehicle_placement_missed: '',
      drafts: ''
    };
    this.onClickparentTab('total')
    let filteredIndents = alldata;

    if (rfqform.active === 'activet') {
      filteredIndents = originalindents.filter(e => e.indent_expired != 1);
    } else if (rfqform.cancelled === 'activet') {
      filteredIndents = originalindents.filter(e => e.indent_expired == 1);
    }

    this.setState({
      rfqform: updatedRfqForm,
      allindents: filteredIndents,
      originalindents: alldata,
      searchfilter: {}
    });

    this.getcountersforindents(alldata, []);
  };

  getStatusFromIndent = (indent) => {
    if (localStorage.getItem('user_type') === 'TRANSPORTER') {
      return this.getIndentStatus(indent);
    }

    switch (true) {
      case indent.rejected === 1:
      case indent.indentcancelledbyadmin === 1:
        return 'Indent Rejected';
      case indent.vehicle_placement_expiried === 1:
      case indent.validity_end === 1 && indent.indent_assigned != 1 && indent.approved_changed_l2_as_l1 != 1 || (
        indent.bidding_window &&
        indent.create_date &&
        this.isBiddingWindowExpired(indent.bidding_window, indent.create_date) &&
        indent.vendorquotes &&
        indent.vendorquotes.length === 0 && indent.indent_assigned != 1 && indent.approved_changed_l2_as_l1 != 1
      ):
        return 'Expired';

      case indent.is_draft === 1:
        return 'Draft';
      case indent.truck_details_completed === 1:
        return 'Vehicle Placed';
      case indent.indent_rejected_by_vendor === 1:
        return 'Award Declined';
      case indent.waiting_for_approval1 === 1 && indent.changed_l2_as_l1 == 1:
        return 'Awaiting Approval to Consider L2 as L1';
      case indent.waiting_for_approval1 === 1 && indent.started_truck_details != 1 && indent.indent_accepted_by_vendor != 1:
        return 'Awaiting Approval';
      case indent.vendorquotes &&  this.isBiddingWindowExpired(indent.bidding_window, indent.create_date) && indent.started_truck_details != 1 && indent.indent_assigned != 1:
        return 'Negotiation In Progress';
      case indent.approved_changed_l2_as_l1 === 1:
        return 'Negotiation In Progress';
      case indent.vendorquotes && indent.vendorquotes.some(e => e.vendor_email_id == indent.accepted_vendor && e.indent_accepted_by_vendor == 1) && indent.truck_details_completed != 1:
        return 'Awaiting Truck Details'
      case indent.approvedwithapproval2 === 1:
        return 'Indent Awarded';

      case indent.vendorquotes && indent.vendorquotes.length === 0:
        return 'Bidding In Progress';
      case indent.quantity === indent.confirmed_quantity || indent.indent_assigned === 1:
        return 'Indent Awarded';
      default:
        return 'Bidding In Progress';
    }
  };

  getindents = (e) => {
    e.preventDefault();
    const { alldata, searchfilter } = this.state;


    const filteredIndents = alldata.filter((item) => {
      return Object.entries(searchfilter).every(([key, value]) => {
        if (!value) return true;

        if (key === 'status') {
          const currentStatus = this.getStatusFromIndent(item);
          return currentStatus.toLowerCase() === value.toLowerCase();
        }

        if (item[key] && typeof item[key] === 'string' && typeof value === 'string') {
          return item[key].toLowerCase() === value.toLowerCase();
        } else {
          return item[key] == value;
        }
      });
    });
    this.onClickparentTab("total")
    this.setState({
      allindents: filteredIndents,
      draftdata: [],
      originalindents: filteredIndents
    });
    this.getcountersforindents(filteredIndents, []);
  };
  onClickchildTab = (selectedChildTab) => {
    this.setState({ selectedChildTab });
    this.setState({ selectedSubTab: selectedChildTab });

    this.setState({ selectedTabforparent: `Active Indents - ${selectedChildTab}` });
    let activedata
    let bidding_in_progress_data
    let waiting_for_approval_data
    let waiting_for_quote_data
    if (localStorage.getItem('rfq_role') == 'ADMIN') {
      activedata = this.state.originalindents.filter(
        item =>
          item.vendordetails &&
          item.vendordetails.length > 0 &&
          item.indent_assigned !== 1 &&
          item.rejected !== 1 &&
          item.indentcancelledbyadmin !== 1 &&
          (
            item.vendorquotes.length > 0 ||
            !this.isBiddingWindowExpired(item.bidding_window, item.create_date)
          ) &&
          (
            item.validity_end !== 1 || item.approved_changed_l2_as_l1 === 1
          )
      );

    }
    if (localStorage.getItem('user_type') === 'TRANSPORTER') {
      const userEmail = localStorage.getItem('email');

      activedata = this.state.originalindents.filter((e) => {
        const hasValidVendorDetails = e.vendordetails && e.vendordetails.length > 0 && e.indent_assigned !== 1 && e.validity_end !== 1 && e.previous_accepted_vendor != userEmail && e.rejected !== 1;
        const hasPendingDifferentVendor = e.indent_pending_data && e.indent_pending_data.vendor_email_id !== userEmail;
        const hasPreviousDifferentVendorAndMatchingQuote =
          e.previous_accepted_vendor !== userEmail &&
          e.vendorquotes &&
          e.vendorquotes.some(f => f.vendor_email_id === userEmail) &&
          e.vendorquotes.find(g => g.bid_winner != 1) &&
          e.vendorquotes.find(g => g.pending_vendor_approval == 1)
        const isExpiredWithNoQuote =
          this.isBiddingWindowExpired(e.bidding_window, e.create_date) &&
          (!e.vendorquotes || !e.vendorquotes.some(q => q.vendor_email_id === userEmail))

        return (hasValidVendorDetails || hasPendingDifferentVendor || hasPreviousDifferentVendorAndMatchingQuote) && !isExpiredWithNoQuote;
      });
      let username = localStorage.getItem('username');

      activedata = activedata.filter(
        (e) =>
          e.previous_accepted_vendor !== userEmail &&
          e.indentcancelledbyadmin !== 1 &&
          e.indent_cancelled !== 1 &&
          // e.approvedwithapproval2 !== 1 &&
          e.rejected !== 1 &&
          // e.indent_assigned != 1 

          (
            !e.vendors_participation || // if no participation object, allow
            !e.vendors_participation.hasOwnProperty(username) || // if no user key, allow
            e.vendors_participation[username] !== 'declined' // only check if both above are true
          )
      );


      activedata = activedata.filter((e) => {
        const vendorquotes = e.vendorquotes || [];
        if (
          vendorquotes.length > 0 &&
          vendorquotes.some((quote) => quote.vendor_email_id === userEmail)
        ) {
          const vendorquote = vendorquotes.find((quote) => {
            const isValid =
              quote.vendor_email_id === userEmail &&
              quote.indent_rejected_by_vendor !== 1 &&
              quote.indent_accepted_by_vendor !== 1 &&
              quote.vendor_rejected !== 1;

            return (
              isValid ||
              (isValid && e.waiting_for_approval1 == 1 && e.indent_assigned != 1)
            );
          });

          return vendorquote !== undefined;
        }

        return true;
      });

    }

    bidding_in_progress_data = activedata.filter(
      indent => {
        const status = this.getStatusFromIndent(indent);
        return status === 'Negotiation In Progress' || status === 'In Progress';
      }
    );
    waiting_for_approval_data = activedata.filter(indent => {
      return (
        this.getStatusFromIndent(indent) === 'Awaiting Approval' ||
        this.getStatusFromIndent(indent) === 'Awaiting Approval to Consider L2 as L1'
      );
    });


    waiting_for_quote_data = activedata.filter(
      indent => this.getStatusFromIndent(indent) === 'Bidding In Progress'
    );

    let filteredChildData = [];

    switch (selectedChildTab) {
      case 'Negotiation In Progress':
        filteredChildData = bidding_in_progress_data;
        break;

      case 'Awaiting Approval':
        filteredChildData = waiting_for_approval_data;
        break;
      case 'Awaiting Approval to Consider L2 as L1':
        filteredChildData = waiting_for_approval_data;
        break;

      case 'Bidding In Progress':
        filteredChildData = waiting_for_quote_data;
        break;

      default:
        filteredChildData = [];
        break;
    }

    this.setState({
      subcountertab: {
        bidding_in_progress_data: bidding_in_progress_data,
        waiting_for_approval_data: waiting_for_approval_data,
        waiting_for_quote_data: waiting_for_quote_data
      },
      filteredChildData: filteredChildData,
      allindents: filteredChildData
    });
  };
  handleInputChangeforaccept = (index, field, value) => {
    const updatedDestinations = [...this.state.indent_for_approve];
    updatedDestinations[index][field] = value;
    this.setState({ indent_for_approve: updatedDestinations });
  };

  handleInputChangeforacceptfortruck = (index, field, value) => {
    const updatedDestinations = [...this.state.indentfortruckdetails];
    updatedDestinations[index][field] = value;
    this.setState({ indentfortruckdetails: updatedDestinations });
  };

  handleInputChangeforacceptfortruck1 = (index, field, value) => {
    const updatedDestinations = [...this.state.lr_no_data];
    updatedDestinations[index][field] = value;
    this.setState({ lr_no_data: updatedDestinations });
  };

  handleInputChangeforadmin_bifur = (index, field, value) => {
    const updatedDestinations = [...this.state.dataforadminbifur];
    updatedDestinations[index][field] = value;
    this.setState({ dataforadminbifur: updatedDestinations });
  };

  onSubmitdata = () => {
    const { indent_for_approve, selecteddata } = this.state;
    const hasInvalidFields = indent_for_approve.some(destination => !destination.bid_price || !destination.transit_days);

    if (hasInvalidFields) {
      alert("Please fill in all Bid Price and Transit Days fields before submitting.");
      return;
    }

    const submissionData = indent_for_approve.map(destination => ({
      indent_id: destination.indent_id,
      dealer_city: destination.dealer_city,
      dealer_pincode: destination.dealer_pincode,
      bid_price: destination.bid_price,
      transit_days: destination.transit_days,
      material: destination.material,
      vendor_email_id: localStorage.getItem('email'),
      vendor_name: localStorage.getItem('firstname')
    }));

    const params1 = { submissionData };
    redirectURL.post('/consignments/storedata', params1);

    const { indent_id, bid_price, no_of_deliveries, vendor_email_id, indent_created_by } = selecteddata;
    const params = {
      indent_id,
      bid_price,
      no_of_deliveries,
      vendor_email_id,
      email: localStorage.getItem("email"),
      user_type: localStorage.getItem("user_type"),
      indent_created_by
    };

    redirectURL.post("/consignments/acceptNegotiationValue", params).then(response => {
      const isSuccess = response.data.status === "success";
      this.setState({
        showsweetalert: true,
        basicType: isSuccess ? "success" : "danger",
        basicTitle: response.data.message,
      });

      if (isSuccess) {
        this.setState({
          isVendorInputOpen: "",
          isProposedInputOpen: ""
        });
      }
    }).catch(error => {
      console.log(error);
      this.setState({
        showsweetalert: true,
        basicType: "danger",
        basicTitle: "An error occurred while processing the request."
      });
    });
  };

  onshowPreview = (e) => {
    const destinationDetails = JSON.parse(e.destination || '[]');
    this.setState({
      isPreviewMode: true,
      rfqform: e,
      dealers: destinationDetails
    });
  };

  onSubmitdata1 = (e) => {
    const { lr_no_data, indentfortruckdetails } = this.state;
    let submissionData = [];

    if (e.started_truck_details === 1) {
      submissionData = lr_no_data.map(destination => ({
        indent_id: destination.indent_id,
        dealer_city: destination.dealer_city,
        dealer_pincode: destination.dealer_pincode,
        truck_no: destination.truck_no,
        bid_price: destination.bid_price,
        lr_no: destination.lr_no || null
      }));
    } else {
      submissionData = indentfortruckdetails.map(destination => ({
        indent_id: destination.indent_id,
        dealer_city: destination.dealer_city,
        dealer_pincode: destination.dealer_pincode,
        truck_no: destination.truck_no,
        bid_price: destination.bid_price,
        lr_no: destination.lr_no || null,
        submitted: 1,
        started_truck_details: 1
      }));
    }

    const params1 = { submissionData };
    redirectURL.post('/consignments/storetruckdetails', params1).then(resp => {
      this.setState({
        showsweetalert: true,
        basicType: "success",
        basicTitle: 'Truck details updated successfully',
        vehicleDetailsModel: false,
        showBidDetailsSlider1: false
      });
      this.resetindent();
      emitDataReceived({})
    });
  };

  handleInputChange = (e) => {
    this.setState({ selected_transit_days: e });
  };

  handleInputChange1 = (e) => {
    this.setState({ selected_bid_price: e });
  };
  handleBidPriceChange = (value) => {
    this.setState({ selected_bid_price: value });
  };

  handleTransitDaysChange = (value) => {
    this.setState({ selected_transit_days: value });
  };
  onSubmitquote = (e) => {
    e.preventDefault();
    const {
      selected_bid_price,
      selected_transit_days,
      selectedindent,
      indent_for_approve_for_bid
    } = this.state;

    const params = {
      bid_price: selected_bid_price,
      transit_time: selected_transit_days,
      email: localStorage.getItem('email'),
      indent_id: selectedindent.indent_id,
      username: localStorage.getItem('user_name')
    };

    this.setState({ loadshow: 'show-m', overlay: 'show-m' });
    redirectURL.post('/consignments/storeaccepflag', { 'indent_id': selectedindent.indent_id, 'vendor_name': localStorage.getItem('username'), 'vendor_email_id': localStorage.getItem('email') }).then((resp) => {
      if (resp.data.status === 'failure' && resp.data.message === "Bidding time has ended. You cannot accept the indent.") {
        this.setState({
          showsweetalert: true,
          basicType: 'danger',
          basicTitle: resp.data.message,
          showsliderforbid: false,
          loadshow: 'show-n',
          overlay: 'show-n',

        });
        this.resetindent()
        return;
      }
      else {
        redirectURL.post('consignments/submitQuote', params).then(response => {
          if (response.data.status === 'success') {
            this.setState({
              loadshow: 'show-n',
              overlay: 'show-n',
              isCardOpen: "",
              showsweetalert: true,
              basicType: "success",
              basicTitle: 'Your bid has been successfully placed',
              selected_bid_price: "",
              selected_transit_days: "",
              showsliderforbid: false,
            });

            this.resetindent();
            emitDataReceived({ action: "Submit Bid" })
          }
        });

        const submissionData = indent_for_approve_for_bid.map(destination => ({
          indent_id: selectedindent.indent_id,
          dealer_city: destination.dealer_city,
          dealer_pincode: destination.dealer_pincode,
          bid_price: destination.bid_price,
          transit_days: destination.transit_days,
          material: destination.material,
          vendor_email_id: localStorage.getItem('email'),
          vendor_name: localStorage.getItem('firstname')
        }));

        const params3 = { submissionData, indent_id: selectedindent.indent_id };
        redirectURL.post('/consignments/updatebidprice', params3);

        const params1 = { submissionData };
        redirectURL.post('/consignments/storedata', params1);
      }
    })

  };

  closeAlert = () => {
    this.setState({ showsweetalert: false, open: false });
  };


  onIconHover = (rowId) => {
    this.setState({ hoveredIconId: rowId });
  };
  onClickViewPOD = (e) => {
    let indent = e.data.indent
    const params = { pod_document: indent.upload_for_road };
    redirectURL.post("/billing/downloadfileforroad", params, {
      headers: {
        'Content-Type': 'application/json',
        'Authorization': localStorage.getItem("userid")
      }
    }).then(res => {
      const downloadUrl = decodeURIComponent(res.data.url);
      const link = document.createElement("a");
      link.href = downloadUrl;
      link.setAttribute("download", e || "");
      link.setAttribute("target", "_blank");
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    }).catch(error => {
      // Handle error silently
    });
  };

  onClickcreateindent = () => {
    this.setState({ redirect: true });
  };
  tabNames = localStorage.getItem('user_type') === 'TRANSPORTER'
    ? {
      Active: "Active Indents",
      Awarded: "Awarded Indents",
      Delivered: "Delivered Indents",
      vendorrejected: "Vendor Declined Indents",
      Drafts: "Draft Indents",
      rejected: "Rejected Indents",
      Completed: "Expired Indents",
      total: "All Indents"
    }
    : {
      Active: "Active Indents",
      Awarded: "Awarded Indents",
      Delivered: "Delivered Indents",
      vendorrejected: "Award Declined Indents",
      Drafts: "Draft Indents",
      rejected: "Rejected Indents",
      Completed: "Expired Indents",
      total: "All Indents"
    };
  onClickparentTab = (e) => {
    const current_date = new Date();
    const tabLabel = this.tabNames[e] || e;
    this.setState({ selectedTab: tabLabel, selectedTabforparent: tabLabel });
    let data = [];

    const userType = localStorage.getItem('user_type');
    const userEmail = localStorage.getItem('email');

    const setRfqFormField = (field) => {
      this.setState(prev => ({
        rfqform: {
          ...prev.rfqform,
          cancelled: '',
          total: '',
          active: '',
          completed: '',
          awarded: '',
          rejected: '',
          Delivered: '',
          vendorrejected: '',
          vehicle_placement_missed: '',
          drafts: '',
          [field]: 'activet1'
        }
      }));
    };

    if (e === 'total') {
      setRfqFormField('total');
      data = userType === 'TRANSPORTER'
        ? this.state.originalindents.filter(item => item.vendors.some(vendor => vendor === userEmail))
        : [...this.state.originalindents, ...this.state.draftdata];
    }
    else if (e === 'Delivered') {
      setRfqFormField('Delivered');
      data = this.state.originalindents.filter(item => item.allDelivered === 1);
    }
    else if (e === 'Awarded') {
      setRfqFormField('awarded');
      if (userType === 'TRANSPORTER') {
        data = this.state.originalindents.filter(item =>
          item.accepted_vendor === userEmail &&
          item.vehicle_placement_expiried !== 1 &&
          item.rejected !== 1
        ).filter(item => {
          const q = item.vendorquotes || [];
          const vendorquote = q.find(quote =>
            (quote.vendor_email_id === userEmail &&
              quote.indent_rejected_by_vendor !== 1 &&
              quote.indent_accepted_by_vendor === 1) ||
            quote.bid_winner === 1
          );
          return vendorquote !== undefined;
        });
      } else {
        data = this.state.originalindents.filter(item =>
          item.indent_assigned === 1 &&
          item.indent_rejected_by_vendor !== 1 &&
          item.vehicle_placement_expiried !== 1 &&
          item.indent_cancelled !== 1 && item.rejected != 1
        );
      }
    }
    else if (e === 'Active') {
      setRfqFormField('active');
      if (userType === 'TRANSPORTER') {
        data = this.state.originalindents.filter(item => {
          const q = item.vendorquotes || [];
          const validDetails = item.vendordetails && item.vendordetails.length > 0 && item.indent_assigned !== 1 && item.validity_end !== 1 && item.approvedwithapproval2 !== 1 && item.rejected !== 1;
          const pendingDifferent = item.indent_pending_data && item.indent_pending_data.vendor_email_id !== userEmail;
          const differentVendorWithQuotes = item.previous_accepted_vendor !== userEmail && q.some(f => f.vendor_email_id === userEmail) && q.find(g => g.bid_winner !== 1);
          const expiredWithoutQuote = this.isBiddingWindowExpired(item.bidding_window, item.create_date) && (!q || !q.some(x => x.vendor_email_id === userEmail));
          return (validDetails || pendingDifferent || differentVendorWithQuotes) && !expiredWithoutQuote;
        }).filter(item =>
          item.previous_accepted_vendor !== userEmail &&
          item.indentcancelledbyadmin !== 1 &&
          item.indent_cancelled !== 1 &&
          item.approvedwithapproval2 !== 1 &&
          item.rejected !== 1 &&
          item.vendors_participation &&
          item.vendors_participation.hasOwnProperty(localStorage.getItem('username')) &&
          item.vendors_participation[localStorage.getItem('username')] !== 'declined'
        ).filter(item => {
          const q = item.vendorquotes || [];
          if (q.length && q.some(quote => quote.vendor_email_id === userEmail)) {
            const vendorquote = q.find(quote => quote.vendor_email_id === userEmail && quote.vendor_rejected !== 1 && quote.indent_rejected_by_vendor !== 1);
            return vendorquote !== undefined;
          }
          return true;
        }).filter(item => {
          const q = item.vendorquotes || [];
          if (q.length && q.some(quote => quote.vendor_email_id === userEmail)) {
            const vendorquote = q.find(quote => quote.vendor_email_id === userEmail && quote.indent_rejected_by_vendor !== 1 && quote.indent_accepted_by_vendor !== 1 && quote.vendor_rejected !== 1 && item.approvedwithapproval2 !== 1 && item.validity_end !== 1);
            return vendorquote !== undefined;
          }
          return true;
        });
      } else {
        data = this.state.originalindents.filter(item =>
          item.vendordetails &&
          item.vendordetails.length > 0 &&
          item.indent_assigned !== 1 &&
          item.rejected !== 1 &&
          item.indentcancelledbyadmin !== 1 &&
          (
            item.vendorquotes.length > 0 ||
            !this.isBiddingWindowExpired(item.bidding_window, item.create_date)
          ) &&
          (
            item.validity_end !== 1 || item.approved_changed_l2_as_l1 === 1
          )
        );
      }



    }
    else if (e === 'Completed') {
      setRfqFormField('completed');

      if (localStorage.getItem('rfq_role') == 'ADMIN') {
        data = this.state.originalindents.filter(e => e.rejected != 1 && e.indent_assigned != 1 && e.approved_changed_l2_as_l1 != 1)
        data = data.filter(
          item =>
            (this.isBiddingWindowExpired(item.bidding_window, item.create_date) && item.rejected != 1 &&
              item.vendorquotes.length === 0) || (item.validity_end === 1 || item.vehicle_placement_expiried === 1)
        );
      }
      else {
        const username = localStorage.getItem('username');
        const userEmail = localStorage.getItem('email');
        data = this.state.originalindents.filter(e => e.accepted_vendor != userEmail)
        data = data.filter(item => {
          const vendorQuotes = item.vendorquotes || [];

          const isExpired =
            item.validity_end === 1 ||
            item.vehicle_placement_expiried === 1 ||
            this.isBiddingWindowExpired(item.bidding_window, item.create_date)

          const notQuoted = !vendorQuotes.some(x => x.vendor_email_id === userEmail && x.negotiation_closed != 1) && this.isBiddingWindowExpired(item.bidding_window, item.create_date) && item.previous_accepted_vendor != userEmail && (
            ((item.vendors_participation &&
              typeof item.vendors_participation === 'object' &&
              !item.vendors_participation.hasOwnProperty(username))) ||
            !item.vendors_participation
          )

          const userDeclined = item.vendors_participation &&
            item.vendors_participation.hasOwnProperty(username) &&
            item.vendors_participation[username] === "declined";
          const isBiddingExpired = this.isBiddingWindowExpired(item.bidding_window, item.create_date);

          const awardedvendor =
            vendorQuotes.some(q => q.vendor_email_id === userEmail && q.bid_winner != 1)

          const declinedByCurrentUser =
            item.vendors_participation &&
            item.vendors_participation.hasOwnProperty(username) &&
            item.vendors_participation[username] === 'declined'
          return ((isExpired) && !declinedByCurrentUser && item.rejected != 1 && item.indent_assigned != 1 && item.waiting_for_approval1 != 1 && item.approvedwithapproval2 != 1 && item.accepted_vendor != userEmail) && notQuoted
        });

      }


    }
    else if (e === 'rejected') {
      const userEmail = localStorage.getItem('email');
      setRfqFormField('rejected');
      if (userType === 'TRANSPORTER') {
        data = this.state.originalindents.filter(e => e.previous_accepted_vendor != localStorage.getItem('email') || e.rejected == 1)
        data = data.filter(item => {
          const quoted = item.vendorquotes.some(x => x.vendor_email_id === userEmail)
          const q = item.vendorquotes || [];
          const isRejected = item.rejected === 1 && q.some(qi => qi.vendor_email_id === userEmail) && item.previous_accepted_vendor != localStorage.getItem('email')
          const match = q.find(quote => quote.vendor_email_id === userEmail && quote.bid_winner === 0 && quote.pending_vendor_approval != 1 && item.approvedwithapproval2 == 1
            && item.accepted_vendor !== userEmail)
          const match1 = q.find(quote => quote.vendor_email_id === userEmail && quote.vendor_rejected == 1)
          return ((isRejected || match !== undefined || match1 || item.indentcancelledbyadmin == 1 || item.rejected == 1) && quoted) || item.rejected == 1
        });
      } else {
        data = this.state.originalindents.filter(item => item.rejected === 1 || item.rejectedwithapproval1 === 1);
      }
    }
    else if (e === 'vendorrejected') {
      setRfqFormField('vendorrejected');
      if (userType === 'TRANSPORTER') {
        let vendorrejecteddata = this.state.originalindents.filter(e => e.indentcancelledbyadmin != 1)
        data = vendorrejecteddata.filter(item => {
          const q = item.vendorquotes || [];
          // current user
          const username = localStorage.getItem('username');

          // true when this user is marked "declined" on the item
          const declinedByCurrentUser =
            item.vendors_participation &&
            item.vendors_participation.hasOwnProperty(username) &&
            item.vendors_participation[username] === 'declined';

          /* ─────────────────────────  CONDITIONS  ───────────────────────── */

          const condition1 =
            (
              q.find(
                quote =>
                  quote.vendor_email_id === userEmail &&
                  quote.indent_rejected_by_vendor === 1
              ) &&
              item.validity_end !== 1 &&
              item.vehicle_placement_expiried !== 1 &&
              item.rejectedwithapproval2 !== 1
            ) ||
            declinedByCurrentUser;

          const condition2 =
            (
              item.previous_accepted_vendor === userEmail &&
              item.validity_end !== 1 &&
              item.vehicle_placement_expiried !== 1 &&
              item.rejectedwithapproval2 !== 1
            ) ||
            declinedByCurrentUser;

          const condition3
            =
            (
              q.some(qi => qi.vendor_email_id != userEmail) && item.indent_rejected_by_vendor == 1

            )
          const condition4 =
            (
              item.previous_accepted_vendor == localStorage.getItem('email')
            )
          return condition1 || condition2 || condition4

        });
      } else {
        data = this.state.originalindents.filter(item => item.indent_rejected_by_vendor === 1 && item.rejected != 1 && item.indentcancelledbyadmin !== 1);
      }
    }
    else if (e === 'vehicle_placement_missed') {
      setRfqFormField('vehicle_placement_missed');
      data = this.state.originalindents.filter(item => item.indentcancelledbyadmin === 1);
    }
    else if (e === 'Drafts') {
      setRfqFormField('drafts');
      data = this.state.draftdata;
    }

    this.setState({ allindents: data });
    if (e === 'Active') {
      this.onClickchildTab('Bidding In Progress');
    }
  };

  getProposedQuantityFromNegotiation(vendor_email_id) {
    const negotiation = this.state.negotiations.find(
      n => n.vendor_email_id === vendor_email_id
    );
    return negotiation && negotiation.proposed_quantity !== undefined
      ? negotiation.proposed_quantity
      : ''; // or 0
  }

  submitNegotiateValue = (indent_id, vendor_email_id, indent_created_by) => {
    const inputValue = this.state.inputTextValues[vendor_email_id];
    const proposed_days = this.state.proposedDays[vendor_email_id] !== undefined
      ? this.state.proposedDays[vendor_email_id]
      : this.getProposedQuantityFromNegotiation(vendor_email_id);
    const params = {
      user_type: localStorage.getItem("user_type"),
      email: localStorage.getItem("email"),
      indent_id,
      negotiated_value: inputValue,
      negotiated_quantity: proposed_days,
      vendor_email_id,
      indent_created_by
    };

    redirectURL.post("/consignments/submitNegotiateValue", params)
      .then(response => {
        const { status, message } = response.data;
        this.setState({
          showsweetalert: true,
          basicType: status === 'success' ? 'success' : 'danger',
          basicTitle: status === 'success' ? 'Your negotiation has been submitted' : 'Please Enter Amount and Days',
          showBidDetailsSlider: false
        });
        this.resetindent();

        if (status === "success") {
          this.setState({
            isProposedInputOpen: "",
            isVendorInputOpen: ""
          });
        }
      })
      .catch(error => {
        this.setState({
          showsweetalert: true,
          basicType: "danger",
          basicTitle: "An error occurred while submitting the negotiation."
        });
      });
  };

  toggleShowAllRecords = () => {
    this.setState((prevState) => ({ showAllRecords: !prevState.showAllRecords }));
  };

  onClickcancelindent = (indent, bid) => {
    const params = { indent, bid };
    redirectURL.post('/consignments/cancelindent', params).then((resp) => {
      this.setState({
        showsweetalert: true,
        basicType: 'success',
        basicTitle: 'Indent cancelled successfully'
      });
      this.resetindent();
    });
  };


  onClickchangerankbtn = (indent) => {
    let bid = indent.vendorquotes
    const params = { indent, bid };

    redirectURL.post('/consignments/changerankforvendorrejection', params).then((resp) => {
      this.setState({
        showsweetalert: true,
        basicType: 'success',
        basicTitle: 'Successfully changed L2 as L1',
        showBidDetailsSlider: false

      });
      this.resetindent();
    });
  };
  render() {

    const columnDefs = [
      {
        headerName: "",
        field: "materials",
        width: 40,
        pinned: 'left',
        cellRenderer: 'Materialcomponent',
        filter: false,

      },
      ...(userType === "TRANSPORTER"
        ? [
          {
            headerName: "",
            field: "_id",
            width: 120,
            pinned: "left",
            cellRenderer: "LoadingAreaLegs",
            filter: false,
          },
        ]
        : []),
      ...(this.state.selectedTab == 'Draft Indents' ? [{
        headerName: "",
        field: "allcomments",
        width: 40,
        pinned: 'left',
        cellRenderer: 'AttachmentButton',
        filter: false,

      },
      {
        headerName: "",
        field: "allcomments",
        width: 40,
        pinned: 'left',
        cellRenderer: 'CommentsButton',
        filter: false,

      },
      {
        headerName: "",
        field: "indent_id",
        width: 70,
        pinned: 'left',
        cellRenderer: "DraftComponent",
        filter: true,
      },] :
        [
          {
            headerName: "",
            field: "allcomments",
            width: 40,
            pinned: 'left',
            cellRenderer: 'BidButton',
            filter: false,

          },
          {
            headerName: "",
            field: "allcomments",
            width: 40,
            pinned: 'left',
            cellRenderer: 'AttachmentButton',
            filter: false,

          },
          {
            headerName: "",
            field: "allcomments",
            width: 40,
            pinned: 'left',
            cellRenderer: 'CommentsButton',
            filter: false,

          },
          {
            headerName: "",
            field: "allcomments",
            width: 40,
            pinned: 'left',
            cellRenderer: 'ViewRFQButton',
            filter: false,

          },
          ...(this.state.selectedTab === "Rejected Indents"
            ? [
            ]
            : [{
              headerName: "",
              field: "allcomments",
              width: 40,
              pinned: "left",
              cellRenderer: "CancelIndentButton",
              filter: false,
            },]),
          // {
          //       headerName: "",
          //       field: "allcomments",
          //       width: 40,
          //       pinned: 'left',
          //        cellRenderer: 'CancelIndentButton',
          //       filter: false,

          //   },
          {
            headerName: "",
            field: "allcomments",
            width: 40,
            pinned: 'left',
            cellRenderer: 'NotificationButton',
            filter: false,

          },
          {
            headerName: "",
            field: "allcomments",
            width: 40,
            pinned: 'left',
            cellRenderer: 'CommentsAllButton',
            filter: false,

          }
        ]),
      ...(userType === "TRANSPORTER"
        ? [

        ]
        : [{
          headerName: "Participants",
          field: "vendor_count",
          width: 120,
          // pinned: "left",
          cellRenderer: "ParticipantsComponent",
          filter: false,
        },]),
      ...(this.state.selectedTab === 'Draft Indents'
        ? [
          {
            headerName: "Draft ID",
            field: "draft_id",
            width: 200,
            //  cellRenderer: "DraftComponent",
            filter: true,
          },
        ]
        : [{
          headerName: "Indent ID",
          field: "indent_id",
          width: 120,
          filter: true,
        }]),
      ...(this.state.selectedTab === 'All Indents'
        ? [
          {
            headerName: "Draft ID",
            field: "draft_id",
            width: 200,
            //  cellRenderer: "DraftComponent",
            filter: true,
          },
          {
            headerName: "Indent ID",
            field: "indent_id",
            width: 120,
            filter: true,
          }
        ]
        : []),
      ...(this.state.selectedTabforparent == 'Active Indents - Bidding In Progress' || this.state.selectedTabforparent == 'Active Indents - Negotiation In Progress'
        ? [
          { headerName: 'Indent Validity (HH:MM)', field: '', width: 130, cellRenderer: 'Indentvaliditycomponent' },

        ]
        : [
        ]),
      ...(this.state.selectedTabforparent == 'Active Indents - Bidding In Progress' || this.state.selectedTab == "All Indents"
        ? [{ headerName: 'Bidding Cutoff (HH:MM:SS)', field: '', width: 170, cellRenderer: 'CountdownRenderer' },

        ]
        : [
        ]),
      ...(this.state.selectedTabforparent == 'Active Indents - Negotiation In Progress' || this.state.selectedTab == "All Indents"
        ? [{ headerName: 'Negotiation Cutoff (HH:MM:SS)', field: '', width: 170, cellRenderer: 'CountdownRendererfornegotaition' },]
        : []),
      // {
      //   headerName: "Draft ID",
      //   field: "indent_id",
      //   width: 250,
      //    cellRenderer: "DraftComponent",
      //   filter: true,
      // },   
      { headerName: 'Status', field: 'status', width: 150 },
      { headerName: 'Source', field: 'source', width: 120 },
      {
        headerName: 'Dealer City',
        field: 'destination',
        headerClass: 'ag-left-header',
        cellClass: 'ag-left-cell',
        width: 150,

        valueGetter: (params) => {
          var val = (params.data && params.data.destination) ? params.data.destination : '';
          return val
            .split(',')
            .map(function (item) {
              return item
                .trim()
                .toLowerCase()
                .replace(/\b\w/g, function (c) { return c.toUpperCase(); });
            })
            .join(', ');
        },

        cellRendererFramework: function (params) {
          const destinations = (params.value || '')
            .split(',')
            .map(function (item) { return item.trim(); })
            .filter(Boolean);

          if (!destinations.length) return '';

          const [showPopup, setShowPopup] = React.useState(false);
          const [popupPos, setPopupPos] = React.useState({ top: 0, left: 0 });
          const badgeRef = React.useRef(null);

          const firstDestination = destinations[0];
          const remainingCount = destinations.length - 1;

          const handleBadgeClick = (e) => {
            e.stopPropagation();
            if (badgeRef.current) {
              const rect = badgeRef.current.getBoundingClientRect();
              setPopupPos({
                top: rect.bottom + window.scrollY,
                left: rect.left + window.scrollX,
              });
              setShowPopup(!showPopup);
            }
          };

          // Close when clicking outside
          React.useEffect(() => {
            const handleClick = (e) => {
              if (showPopup && badgeRef.current && !badgeRef.current.contains(e.target)) {
                setShowPopup(false);
              }
            };
            document.addEventListener("click", handleClick);
            return () => document.removeEventListener("click", handleClick);
          }, [showPopup]);

          return (
            <div className='flex-center-gap-6'>
              <span>{firstDestination}</span>
              {remainingCount > 0 && (
                <span
                  ref={badgeRef}
                  className="badge-blue"
                  onMouseEnter={handleBadgeClick}   // show on hover
                  onMouseLeave={() => setShowPopup(false)}  // close when mouse leaves           className="badge-blue"
                >
                  +{remainingCount}
                </span>
              )}

              {showPopup &&
                ReactDOM.createPortal(
                  <div
                    style={{
                      top: `${popupPos.top}px`,
                      left: `${popupPos.left}px`,
                    }}
                    className="popup-container-for-city"
                  >

                    {destinations.map((city, index) => (
                      <div
                        key={index}
                        className={`city-item ${index !== destinations.length - 1 ? "city-item-border" : ""}`}
                      >
                        {city}
                      </div>
                    ))}
                  </div>,
                  document.body
                )}
            </div>
          );
        }
      }


      , { headerName: 'Bid Start Date', field: 'bid_start_date', width: 150 },
      { headerName: 'Truck Type', field: 'truck_type', width: 140 },
      {
        headerName: 'Total Distance (KM)',
        field: 'total_km',
        width: 120,
        valueGetter: function (params) {
          const km = params.data.total_km;

          if (km && km !== 'undefined') {
            return km;
          } else {
            return '';
          }
        }
      },

      { headerName: 'Pickup Date', field: 'pickup_date', width: 120 },
      {
        headerName: 'Over Length', field: 'over_length', width: 120,
        valueGetter: function (params) {

          if (params.data.indent.over_length == 0 || params.data.indent.over_length == '0') {
            return 'No'
          }
          else {
            return 'Yes'
          }

        },
      },
      {
        headerName: 'Over Breadth', field: 'over_breath', width: 120, valueGetter: function (params) {
          if (params.data.indent.over_breath == 0 || params.data.indent.over_breath == '0') {
            return 'No'
          }
          else {
            return 'Yes'
          }

        },
      },
      // { headerName: 'Quantity', field: 'quantity' },
      // { headerName: 'Confirmed Value', field: 'confirmed_value' },
      { headerName: 'Base Price (₹)', field: 'base_price', width: 120, },

      // {
      //     headerName: "Participants",
      //     field: "vendor_count",
      //     width: 150,
      //     pinned: 'left',
      //     cellRenderer: 'ParticipantsComponent',
      //     filter: false,

      // },
    ]
    const columnDefs1 = [


      ...(this.state.selectedTab == 'Active Indents' && this.state.selectedTabforparent == 'Active Indents - Bidding In Progress'
        ? [
          {
            headerName: "",
            field: "_id",
            pinned: "left",
            cellRenderer: "Actionsforvendorcomponent",
            filter: false,
            resizable: true,
            headerClass: 'ag-left-header',
            cellClass: 'ag-left-cell',
            autoSizeable: true,  // Optional, depending on AG-Grid version
            flex: 1  // Optional: makes it flexible width with others
          }

        ]
        : []),
      {
        headerName: "",
        field: "materials",
        width: 40,
        pinned: 'left',
        cellRenderer: 'Materialcomponent',
        filter: false,
        headerClass: 'ag-left-header',
        cellClass: 'ag-left-cell',

      },
      // {
      //     headerName: "",
      //     field: "_id",
      //     width: 120,
      //     pinned: "left",
      //     cellRenderer: "LoadingAreaLegs",
      //     filter: false,
      //   },
      {
        headerName: "",
        field: "allcomments",
        width: 40,
        pinned: 'left',
        cellRenderer: 'BidButton',
        filter: false,
        headerClass: 'ag-left-header',
        cellClass: 'ag-left-cell',

      },
      {
        headerName: "",
        field: "allcomments",
        width: 40,
        pinned: 'left',
        cellRenderer: 'AttachmentButton',
        filter: false,
        headerClass: 'ag-left-header',
        cellClass: 'ag-left-cell',

      },
      {
        headerName: "",
        field: "allcomments",
        width: 40,
        pinned: 'left',
        cellRenderer: 'CommentsButton',
        filter: false,
        headerClass: 'ag-left-header',
        cellClass: 'ag-left-cell',

      },
      {
        headerName: "",
        field: "allcomments",
        width: 40,
        pinned: 'left',
        cellRenderer: 'ViewRFQButton',
        filter: false,
        headerClass: 'ag-left-header',
        cellClass: 'ag-left-cell',

      },

      {
        headerName: "",
        field: "allcomments",
        width: 40,
        pinned: 'left',
        cellRenderer: 'NotificationButton',
        filter: false,
        headerClass: 'ag-left-header',
        cellClass: 'ag-left-cell',

      },
      {
        headerName: "",
        field: "allcomments",
        width: 40,
        pinned: 'left',
        cellRenderer: 'CommentsAllButton',
        filter: false,
        headerClass: 'ag-left-header',
        cellClass: 'ag-left-cell',

      },
      ...(this.state.selectedTab == 'Awarded Indents'
        ? [
          {
            headerName: "",
            field: "allcomments",
            pinned: "left",
            width: 40,
            cellRenderer: "ViewTruck",
            filter: false,
            resizable: true,
            headerClass: 'ag-left-header',
            cellClass: 'ag-left-cell',
            autoSizeable: true,  // Optional, depending on AG-Grid version
          }

        ]
        : []),


      // {
      //     headerName: "",
      //     field: "_id",
      //     width: 200,
      //     pinned: 'left',
      //     cellRenderer: 'Allactioncomponentforvendor',
      //     filter: false,

      // },
      {
        headerName: "Indent ID",
        field: "indent_id",
        width: 120,
        filter: true,
        headerClass: 'ag-left-header',
        cellClass: 'ag-left-cell',
      },
      ...(this.state.selectedTabforparent == 'Active Indents - Bidding In Progress' || this.state.selectedTab == "All Indents"
        ? [{
          headerName: 'Bidding Cutoff (HH:MM:SS)', field: '', width: 170, cellRenderer: 'CountdownRenderer', headerClass: 'ag-left-header',
          cellClass: 'ag-left-cell',
        },]
        : []),

      ...(this.state.selectedTabforparent == 'Active Indents - Negotiation In Progress' || this.state.selectedTab == "All Indents"
        ? [{ headerName: 'Negotiation Cutoff (HH:MM:SS)', field: '', width: 170, cellRenderer: 'CountdownRendererfornegotaition' },]
        : []),
      {
        headerName: 'Status', field: 'status', headerClass: 'ag-left-header',
        cellClass: 'ag-left-cell', width: 150
      },
      {
        headerName: 'Source', field: 'source', headerClass: 'ag-left-header',
        cellClass: 'ag-left-cell', width: 120
      },
      {
        headerName: 'Dealer City',
        field: 'destination',
        headerClass: 'ag-left-header',
        cellClass: 'ag-left-cell',
        width: 150,

        valueGetter: (params) => {
          var val = (params.data && params.data.destination) ? params.data.destination : '';
          return val
            .split(',')
            .map(function (item) {
              return item
                .trim()
                .toLowerCase()
                .replace(/\b\w/g, function (c) { return c.toUpperCase(); });
            })
            .join(', ');
        },

        cellRendererFramework: function (params) {
          const destinations = (params.value || '')
            .split(',')
            .map(function (item) { return item.trim(); })
            .filter(Boolean);

          if (!destinations.length) return '';

          const [showPopup, setShowPopup] = React.useState(false);
          const [popupPos, setPopupPos] = React.useState({ top: 0, left: 0 });
          const badgeRef = React.useRef(null);

          const firstDestination = destinations[0];
          const remainingCount = destinations.length - 1;

          const handleBadgeClick = (e) => {
            e.stopPropagation();
            if (badgeRef.current) {
              const rect = badgeRef.current.getBoundingClientRect();
              setPopupPos({
                top: rect.bottom + window.scrollY,
                left: rect.left + window.scrollX,
              });
              setShowPopup(!showPopup);
            }
          };

          // Close when clicking outside
          React.useEffect(() => {
            const handleClick = (e) => {
              if (showPopup && badgeRef.current && !badgeRef.current.contains(e.target)) {
                setShowPopup(false);
              }
            };
            document.addEventListener("click", handleClick);
            return () => document.removeEventListener("click", handleClick);
          }, [showPopup]);

          return (
            <div className='flex-center-gap-6'>
              <span>{firstDestination}</span>
              {remainingCount > 0 && (
                <span
                  ref={badgeRef}
                  className="badge-blue"
                  onMouseEnter={handleBadgeClick}   // show on hover
                  onMouseLeave={() => setShowPopup(false)}  // close when mouse leaves           className="badge-blue"
                >
                  +{remainingCount}
                </span>
              )}

              {showPopup &&
                ReactDOM.createPortal(
                  <div
                    style={{
                      top: `${popupPos.top}px`,
                      left: `${popupPos.left}px`,
                    }}
                    className="popup-container-for-city"
                  >
                    {destinations.map((city, index) => (
                      <div
                        key={index}
                        className={`city-item ${index !== destinations.length - 1 ? "city-item-border" : ""}`}
                      >
                        {city}
                      </div>
                    ))}
                  </div>,
                  document.body
                )}
            </div>
          );
        }
      },
      {
        headerName: 'Bid Start Date', field: 'bid_start_date', width: 150, headerClass: 'ag-left-header',
        cellClass: 'ag-left-cell',
      },
      // { headerName: 'Material', field: 'material', width: 150 },
      {
        headerName: 'Truck Type', field: 'truck_type', width: 140, headerClass: 'ag-left-header',
        cellClass: 'ag-left-cell',
      },
      {
        headerName: 'Total Distance (KM)',
        field: 'total_km',
        width: 120,
        headerClass: 'ag-left-header',
        cellClass: 'ag-left-cell',
        valueGetter: function (params) {
          const km = params.data.total_km;

          if (km && km !== 'undefined') {
            return km;
          } else {
            return '';
          }
        }
      },
      // { headerName: 'Total Distance (KM)', field: 'total_km', width: 120 },
      {
        headerName: 'Pickup Date', field: 'pickup_date', width: 120, headerClass: 'ag-left-header',
        cellClass: 'ag-left-cell',
      },
      {
        headerName: 'Over Length', field: 'over_length', width: 120, headerClass: 'ag-left-header',
        cellClass: 'ag-left-cell',
        valueGetter: function (params) {
          if (params.data.indent.over_length == 0 || params.data.indent.over_length == '0') {
            return 'No'
          }
          else {
            return 'Yes'
          }

        },
      },
      {
        headerName: 'Over Breadth', field: 'over_breath', width: 120, headerClass: 'ag-left-header',
        cellClass: 'ag-left-cell', valueGetter: function (params) {
          if (params.data.indent.over_breath == 0 || params.data.indent.over_breath == '0') {
            return 'No'
          }
          else {
            return 'Yes'
          }

        },
      },
      // { headerName: 'Quantity', field: 'quantity' },
      // { headerName: 'Confirmed Value', field: 'confirmed_value' },
      {
        headerName: 'Base Price (₹)', field: 'base_price', headerClass: 'ag-left-header',
        cellClass: 'ag-left-cell', width: 120,
      },

      // {
      //     headerName: "Participants",
      //     field: "vendor_count",
      //     width: 150,
      //     pinned: 'left',
      //     cellRenderer: 'ParticipantsComponent',
      //     filter: false,

      // },
    ]
    const { isPreviewMode, onClosePreview, rfqForm, dealers } = this.state;
    const modalStyles = {
      width: '500px !important'
    };
    const { rfqform, countersfortab, selectedfromdate, selectedenddate, subcountertab } = this.state;
    const columnDef = []
    const status_list = [
      { value: "Awaiting Approval", label: "Awaiting Approval" },
      { value: "Bidding In Progress", label: "Bidding In Progress" },
      { value: "Draft", label: "Draft" },
      { value: "Expired", label: "Expired" },
      { value: "Indent Awarded", label: "Indent Awarded" },
      { value: "In Progress", label: "In Progress" },
      { value: "Negotiation In Progress", label: "Negotiation In Progress" },
      { value: "Rejected", label: "Rejected" },
      { value: "Vehicle Placed", label: "Vehicle Placed" },
      { value: "Vendor Declined", label: "Vendor Declined" }
    ].sort((a, b) => a.label.localeCompare(b.label));

    if (this.state.redirect) {
      return <Redirect to="/createindent" push={true} />;
    }
    if (this.state.bidDetailsform) {
      return (
        <Redirect
          to={{
            pathname: "/biddetails",
            state: {
              indent_id: this.state.selectedIndentData.indent_id
              // selectedIndentData: this.state.selectedIndentData,
              // selectedVendorQuotes: this.state.selectedVendorQuotes,
              // negotiations: this.state.negotiations,
              // selectedindentdata1: this.state.selectedindentdata1,
              // negotiationsLogs: this.state.negotiationsLogs,
              // rfqform: this.state.rfqform,
              // inputTextValues: this.state.inputTextValues,
              // proposedDays: this.state.proposedDays,
              // selectedindent: this.state.selectedindent,
              // dataforadminbifur: this.state.dataforadminbifur,
              // indentfortruckdetails: this.state.indentfortruckdetails
              // onClickAcceptQuotation:this.onClickAcceptQuotation,
              // onShowdata:this.onShowdata

            }
          }}
          push={true}
        />

      );
    }
    var indent = this.state.selectedIndentData
    const today = moment().format('YYYY-MM-DD');
    const oneWeekAgo = moment().subtract(30, 'days').format('YYYY-MM-DD');
    return (
      <div className="custom-container">
        <SweetAlert
          show={this.state.showsweetalert}
          type={this.state.basicType}
          title={this.state.basicTitle}
          confirmBtnCssClass={`btn btn-${this.state.basicType}`}
          onConfirm={this.closeAlert}
        />
        <div className="row align-items-center justify-content-between mb-10p">
          <div className="col-sm-6 mt-30p">
            <h5 className="fbold f20 mb-0">
              <span>Indent Summary</span>
            </h5>
          </div>

          <div className="col-sm-6 d-flex justify-content-end indentActionContainer">
            {localStorage.getItem('rfq_role') == 'ADMIN' ? (

              <>
                <div
                  className="custom-datepicker custom-datepicker_style"
                >
                  <Datepicker
                    onDatesSelected={this.handleDatesSelected}
                    onRefreshSelected={this.refreshSelected}
                    fromDate={this.state.selectedfromdate}
                    toDate={this.state.selectedenddate}
                    className="dealerbtn-save"
                  />

                  {/* {(this.state.selectedfromdate || this.state.selectedenddate) && (
                    <span
                      className="clear-icon input-icon"
                      onClick={() => {
                        this.setState(
                          {
                            selectedfromdate: oneWeekAgo,
                            selectedenddate: today,
                          },
                          () => {
                            if (this.fetchInitialData) {
                              this.fetchInitialData();
                            }
                          }
                        );
                      }}
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 20 20"
                        fill="none"
                        width="18"
                        height="18"
                        stroke="red"
                        strokeWidth="2"
                      >
                        <line x1="5" y1="5" x2="15" y2="15" />
                        <line x1="15" y1="5" x2="5" y2="15" />
                      </svg>
                    </span>
                  )} */}
                </div>
                <button
                  type="button"
                  className="btn btn-default float-right indentFilterBtn"
                >
                  <img
                    className="mx-2 indentIcon"
                    onClick={() =>
                      this.setState((prev) => ({ filterToggle: !prev.filterToggle }))
                    }
                    src={Filter1}
                    title="Filters"
                  />
                </button>

                <button
                  className="btn  mr-2 createindentbtn"
                  onClick={this.onClickcreateindent}
                >
                  Create Indent
                </button>

              </>
            ) : (
              <>
                <div
                  className="custom-datepicker custom-datepicker_style"
                >
                  <Datepicker
                    onDatesSelected={this.handleDatesSelected}
                    onRefreshSelected={this.refreshSelected}
                    fromDate={this.state.selectedfromdate}
                    toDate={this.state.selectedenddate}
                  />

                  {/* {(this.state.selectedfromdate || this.state.selectedenddate) && (
                    <span
                      className="clear-icon input-icon"
                      onClick={() => {
                        this.setState(
                          {
                            selectedfromdate: oneWeekAgo,
                            selectedenddate: today,
                          },
                          () => {
                            if (this.fetchInitialData) {
                              this.fetchInitialData();
                            }
                          }
                        );
                      }}
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 20 20"
                        fill="none"
                        width="18"
                        height="18"
                        stroke="red"
                        strokeWidth="2"
                      >
                        <line x1="5" y1="5" x2="15" y2="15" />
                        <line x1="15" y1="5" x2="5" y2="15" />
                      </svg>
                    </span>
                  )} */}
                </div>
                <button
                  type="button"
                  className="btn btn-default float-right indentFilterBtnAlt"
                >
                  <img
                    className="mx-2 indentIcon"
                    onClick={() =>
                      this.setState((prev) => ({ filterToggle: !prev.filterToggle }))
                    }
                    src={Filter1}
                    title="Filters"
                  />

                </button>
              </>
            )}
          </div>
        </div>
        {this.state.filterToggle && (
          <div className="filter-in">
            <div className="row d-flex justify-content-center mt-20p">
              <div className="col-xl-12 col-lg-12">
                <div className="card shadow-sm">
                  <div className="card-body card-body-custom_pd">
                    <form className="row" onSubmit={this.getindents}>
                      <div className="col-md-3 mb-3">
                        <label>Indent ID</label>
                        <Select
                          isMulti
                          id="indent_id"
                          value={
                            this.state.searchfilter.indent_id
                              ? [{ label: this.state.searchfilter.indent_id, value: this.state.searchfilter.indent_id }]
                              : []
                          }
                          onChange={(selectedOptions) =>
                            this.handleSelectChange(
                              "indent_id",
                              selectedOptions && selectedOptions.length > 0
                                ? selectedOptions[selectedOptions.length - 1]
                                : null
                            )
                          }
                          options={this.state.alldata.map(function (e) {
                            return { label: e.indent_id, value: e.indent_id };
                          })}
                          styles={customSelectStyles}
                        />
                      </div>

                      <div className="col-md-3 mb-3">
                        <label>Source</label>
                        <Select
                          isMulti
                          value={
                            this.state.searchfilter.source
                              ? [{ label: this.state.searchfilter.source, value: this.state.searchfilter.source }]
                              : []
                          }
                          onChange={(selectedOptions) =>
                            this.handleSelectChange(
                              "source",
                              selectedOptions && selectedOptions.length > 0
                                ? selectedOptions[selectedOptions.length - 1]
                                : null
                            )
                          }
                          options={[].concat(
                            Array.from(
                              new Set(
                                this.state.alldata
                                  .map(function (e) {
                                    return e.source;
                                  })
                                  .filter(function (source) {
                                    return source;
                                  })
                              )
                            ).map(function (source) {
                              return { label: source, value: source };
                            })
                          )}
                          styles={customSelectStyles}
                        />
                      </div>

                      <div className="col-md-3 mb-3">
                        <label>Status</label>
                        <Select
                          isMulti
                          value={
                            this.state.searchfilter.status
                              ? [{ label: this.state.searchfilter.status, value: this.state.searchfilter.status }]
                              : []
                          }
                          onChange={(selectedOptions) =>
                            this.handleSelectChange(
                              "status",
                              selectedOptions && selectedOptions.length > 0
                                ? selectedOptions[selectedOptions.length - 1]
                                : null
                            )
                          }
                          options={status_list}
                          styles={customSelectStyles}
                        />
                      </div>

                      <div className="col-md-3 mb-3">
                        <label>Truck Type</label>
                        <Select
                          isMulti
                          value={
                            this.state.searchfilter.type_of_truck
                              ? [
                                {
                                  label: this.state.searchfilter.type_of_truck,
                                  value: this.state.searchfilter.type_of_truck,
                                },
                              ]
                              : []
                          }
                          onChange={(selectedOptions) =>
                            this.handleSelectChange(
                              "type_of_truck",
                              selectedOptions && selectedOptions.length > 0
                                ? selectedOptions[selectedOptions.length - 1]
                                : null
                            )
                          }
                          options={this.state.truck_list}
                          styles={customSelectStyles}
                        />
                      </div>

                      <div className="col-md-12 d-flex justify-content-end">
                        <button
                          type="button"
                          onClick={this.resetSearchFilter}
                          className="btn-cancel-outline"
                        >
                          Cancel
                        </button>
                        <button type="submit" className="btn-submit-solid mr-2">
                          Search
                        </button>
                      </div>
                    </form>

                  </div>
                </div>
              </div>
            </div>
          </div>
        )}
        <div className="d-flex justify-content-center sub-tab-container mt-3">
          <div
            className={`sub-tab border-end ${rfqform.active}`}
            onClick={() => this.onClickparentTab('Active')}
          >
            <div className="summary-icon text-success">
              <img src={require('../../assets/images/activeicon.svg')} />
            </div>
            <div className={`summary-label ${rfqform.active}`}>Active</div>
            <div className="summary-count text-success">{countersfortab.activecount}</div>
            {rfqform.active === 'activet1' &&
              <div className="tab-arrow"></div>}
          </div>
          <div className={`sub-tab border-end ${rfqform.awarded}`} onClick={() => this.onClickparentTab('Awarded')}>
            <div className="summary-icon text-warning"><img src={require('../../assets/images/trophy (1).svg')} /></div>
            <div className={`summary-label ${rfqform.awarded}`}>Awarded</div>
            <div className="summary-count text-warning">{countersfortab.awardcount}</div>
            {rfqform.awarded === 'activet1' && <div className="tab-arrow"></div>}
          </div>
          <div className={`sub-tab border-end ${rfqform.vendorrejected}`} onClick={() => this.onClickparentTab('vendorrejected')}>
            <div className="summary-icon text-danger"><img src={require('../../assets/images/decline.svg')} /></div>
            <div className={`summary-label ${rfqform.vendorrejected}`}>{localStorage.getItem('user_type') == 'TRANSPORTER' ? 'Declined' : 'Award Declined'}</div>
            <div className="summary-count text-danger">{countersfortab.vendorrejectedcount}</div>
            {rfqform.vendorrejected === 'activet1' && <div className="tab-arrow"></div>}
          </div>
          <div className={`sub-tab border-end ${rfqform.rejected}`} onClick={() => this.onClickparentTab('rejected')}>
            <div className="summary-icon text-dark"> <img src={require('../../assets/images/forbidden.svg')} /></div>
            <div className={`summary-label ${rfqform.rejected}`}>Rejected</div>
            <div className="summary-count text-dark">{countersfortab.rejectedcount}</div>
            {rfqform.rejected === 'activet1' && <div className="tab-arrow"></div>}
          </div>
          <div className={`sub-tab border-end ${rfqform.completed}`} onClick={() => this.onClickparentTab('Completed')}>
            <div className="summary-icon text-warning"> <img src={require('../../assets/images/expired.svg')} /></div>
            <div className={`summary-label ${rfqform.completed}`}>Expired</div>
            <div className="summary-count text-warning">{countersfortab.expiredcount}</div>
            {rfqform.completed === 'activet1' && <div className="tab-arrow"></div>}
          </div>
          {localStorage.getItem('rfq_role') == 'ADMIN' && (
            <div className={`sub-tab border-end ${rfqform.drafts}`} onClick={() => this.onClickparentTab('Drafts')}>
              <div className="summary-icon text-secondary"><img src={require('../../assets/images/draft (1).svg')} /></div>
              <div className={`summary-label ${rfqform.drafts}`}>Drafts</div>
              <div className="summary-count text-secondary">{countersfortab.draftscount}</div>
              {rfqform.drafts === 'activet1' && <div className="tab-arrow"></div>}

            </div>
          )}
          <div className={`sub-tab border-end ${rfqform.total}`} onClick={() => this.onClickparentTab('total')}>
            <div className="summary-icon text-success">        <img src={require('../../assets/images/all-inclusive.svg')} />
            </div>
            <div className={`summary-label ${rfqform.total}`}>All</div>
            <div className="summary-count text-success">{countersfortab.totalcount}</div>
            {rfqform.total === 'activet1' && <div className="tab-arrow"></div>}
          </div>
        </div>
        {this.state.selectedTab === 'Active Indents' && (
          <div className="d-flex justify-content-center sub-tab-container mt-30p">
            <div
              className="sub-tab border-end sub-tab-center"
              onClick={() => this.onClickchildTab('Bidding In Progress')}
            >
              <img src={require('../../assets/images/hour-glass.svg')} />
              <div
                className={`bidding-progress ${this.state.selectedSubTab === "Bidding In Progress"
                  ? "fw-semibold"
                  : "fw-medium"
                  }`}
              >
                Bidding In Progress
              </div>
              <div
                className={`bidding-progress ${this.state.selectedSubTab === "Bidding In Progress"
                  ? "fw-semibold"
                  : "fw-medium"
                  }`}
              >
                {subcountertab.waiting_for_quote_data.length}
              </div>
              {this.state.selectedSubTab === 'Bidding In Progress' && <div className="tab-arrow1"></div>}
            </div>
            {/* Negotiation In Progress */}
            <div
              className="sub-tab text-warning border-end"
              onClick={() => this.onClickchildTab('Negotiation In Progress')}
            >
              <img src={require('../../assets/images/negotiation.svg')} />
              <div
                className={
                  this.state.selectedSubTab === "Negotiation In Progress"
                    ? "fw-semibold"
                    : "fw-medium"
                }
              >
                Negotiation In Progress
              </div>
              <div
                className={
                  "sub-tab-count text-warning " +
                  (this.state.selectedSubTab === "Negotiation In Progress"
                    ? "fw-semibold"
                    : "fw-medium")
                }
              >
                {subcountertab.bidding_in_progress_data.length}
              </div>
              {this.state.selectedSubTab === 'Negotiation In Progress' && <div className="tab-arrow1"></div>}
            </div>
            {/* Awaiting Approval */}
            <div
              className="sub-tab text-primary"
              onClick={() => this.onClickchildTab('Awaiting Approval')}
            >
              <img src={require('../../assets/images/21.svg')} />
              <div
                className={
                  this.state.selectedSubTab === "Awaiting Approval"
                    ? "fw-600"
                    : "fw-500"
                }
              >
                Awaiting Approval
              </div>
              <div
                className={`sub-tab-count text-primary ${this.state.selectedSubTab === "Awaiting Approval" ? "fw-600" : "fw-500"
                  }`}
              >
                {subcountertab.waiting_for_approval_data.length}
              </div>
              {this.state.selectedSubTab === 'Awaiting Approval' && <div className="tab-arrow1"></div>}
            </div>
          </div>
        )}
        {this.state.allindents.length == 0 && (
          <div className="centered-container mt-30p">
            <h4 className="no-margin">No Indents Found</h4>
          </div>
        )}
        {this.state.allindents.length > 0 &&
          <div className="card height-equal equal-height-lg card-equal-container">
            <div className="card-header aggridheader-container">
              <h5 className="no-margin">
                <span>{this.state.selectedTabforparent}</span>
              </h5>
              <div className="flex-center-gap-10">
                {this.state.selectedTab == 'Draft Indents' ?
                  <span className="float-right float-right-text">
                    <img src={require('../../assets/images/box.png')} className="icon-small" />
                    Materials

                    <img src={require('../../assets/images/downloadfilesvg.svg')} className="icon-small" />
                    Download

                    <img src={require('../../assets/images/chat.svg')} className="icon-small" />
                    Comments

                    <img src={require('../../assets/icons/pencil.svg')} className="icon-small" />
                    Edit Draft

                    <img src={require('../../assets/icons/delete.svg')} className="icon-small-short" />
                    Delete Draft
                  </span>
                  :
                  <span className="float-right float-right-text">
                    <img src={require('../../assets/images/box.svg')} className="icon-small" />
                    Materials
                    <img src={require('../../assets/images/bidenable.svg')} className="icon-small" />
                    Bid Details
                    <img src={require('../../assets/images/downloadfilesvg.svg')} className="icon-small" />
                    Download
                    <img src={require('../../assets/images/chat.svg')} className="icon-small" />
                    Comments
                    <img src={require('../../assets/images/eye (1).svg')} className="icon-small-short" />
                    View Indent
                    <img src={require('../../assets/images/forbidden.svg')} className="icon-small" />
                    Reject Indent
                    <img src={require('../../assets/images/notification.svg')} className="icon-small" />
                    Notifications
                    <i className="icofont icofont-history f18 icon-small"></i>
                    Logs
                  </span>
                }
                <button
                  className="refresh-btn-wrapper"
                  title="Refresh"
                  onClick={this.refreshindent}
                >
                  <img src={require('../../assets/images/refreshicon.png')} alt="Refresh" className="refresh-icon" />
                </button>
              </div>
            </div>
            <div className="card-body aggridcard-body">
              <div id="myGrid" className="ag-theme-balham" style={{
                height: Math.max(250, Math.min(500, 50 + this.state.rowData.length * 40)), // 50 is header, 30 per row
                width: '100%',
                transition: 'height 0.3s ease'
              }} >
                <AgGridReact
                  rowData={this.state.rowData}
                  columnDefs={localStorage.getItem('user_type') === 'TRANSPORTER' ? columnDefs1 : columnDefs}
                  defaultColDef={{
                    ...this.state.defaultColDef,
                    cellClass: 'ag-left-cell',
                    headerClass: 'ag-left-header'
                  }} frameworkComponents={{ ViewTruck, CommentsAllButton, BidButton, AttachmentButton, ViewRFQButton, CancelIndentButton, NotificationButton, CommentsButton, Vendorparticipationscomponent, Actionsforvendorcomponent, LoadingAreaLegs, Allactioncomponent, ParticipantsComponent, DraftComponent, CountdownRenderer, CountdownRendererfornegotaition, Indentvaliditycomponent, Allactioncomponentforvendor, Materialcomponent }}
                  masterDetail={true}
                  gridOptions={{
                    context: { componentParent: this }  // ✅ THIS IS REQUIRED
                  }} detailCellRendererParams={this.state.detailCellRendererParams}
                  pagination={true}
                  paginationPageSize={100}
                  rowHeight={40}
                  headerHeight={50}
                  rowSelection='true'
                  enableRangeSelection={true}
                  loadingOverlayComponentParams={{ loadingMessage: '' }}
                  onGridReady={this.onGridReady}
                // domLayout="autoHeight"
                />
              </div>
            </div>
          </div>}
        <div
          className={`slide-r ${this.state.modelForNotifications ? "slider-translate-30p" : ""} slider-right`}
        >
          <div className="modalheader-container">
            <div className="modalheader-row">
              <span>Notifications</span>
              <button className="modalclosebtn" onClick={this.onCloseModal}>×</button>
            </div>
          </div>

          <div className="scrollablecontainer">
            <div className="indent-id-wrapper">
              {/* <span className="indent-id-label">Indent ID</span> */}
              <span className="indent-id-value">{this.state.selectedindentfornofication}</span>
            </div>
            <hr className="indent-id-divider" />

            {(this.state.notificationUnread.length > 0 || this.state.notificationRead.length > 0) ? (
              <ul className="notification-list">
                {[...this.state.notificationUnread, ...this.state.notificationRead].map((notification, index) => {
                  const isNewIndent = notification.notification.startsWith("A New Indent");

                  return (
                    <li key={index} className="notification-item">
                      <div className="notification-header">
                        <span className="notification-title">{notification.notification_from}</span>
                        <span className="notification-date">
                          {getHyphenDDMMYYYYHHMM(notification.create_date)}
                        </span>
                      </div>
                      <div className="notification-message">
                        {notification.notification}
                      </div>

                      {isNewIndent && (
                        <div className="notification-disclaimer disclaimer-bold">
                          <span className='mr-6p'>⚠️</span>
                          DISCLAIMER: Response is mandatory
                        </div>
                      )}
                    </li>
                  );
                })}
              </ul>

            ) : (
              <p className="no-notifications">No notifications available.</p>
            )}
          </div>
        </div>
        <div
          className={
            "slide-r " +
            (this.state.showsliderforbid ? "slider-translate-30p" : "") +
            " slider-right"
          }
        >   <div className="place-bid-header">
            <span>Place Bid</span>
            <button className="close-btn" onClick={this.onCloseSlider}>×</button>
          </div>

          <div className="place-bid-body">
            <div className="indent-info">
              Indent ID&nbsp;&nbsp;&nbsp;<b>{this.state.selected_for_placebid}</b>
            </div>
            {/* <div className="indent-id-wrapper">
              <span className="indent-id-label">Indent ID</span>
              <span className="indent-id-value">{this.state.selected_for_placebid}</span>
            </div> */}


            <form className="bid-form" onSubmit={this.onSubmitquote}>
              <div className="form-group">
                <label>Bid Price (₹) <span className='err-txt'>*</span></label>
                <input
                  type="text"
                  value={this.state.selected_bid_price === '0' ? '' : this.state.selected_bid_price}
                  onChange={(e) => {
                    let value = e.target.value;

                    // Allow empty (for clearing)
                    if (value === '') {
                      this.handleBidPriceChange('');
                      return;
                    }

                    // Allow only digits
                    if (!/^\d+$/.test(value)) return;

                    // Prevent multiple leading zeros (e.g., '00', '0000')
                    if (value.length > 1 && value.startsWith('0')) return;

                    // Ensure number > 0
                    if (parseInt(value, 10) > 0) {
                      this.handleBidPriceChange(value);
                    }
                  }}
                  className="form-control"
                  placeholder="Enter Bid Price"
                  required
                />
              </div>

              <div className="form-group">
                <label>Transit Days <span className='err-txt'>*</span></label>
                <input
                  type="text"
                  value={this.state.selected_transit_days === '0' ? '' : this.state.selected_transit_days}
                  onChange={(e) => {
                    let value = e.target.value;

                    // Allow empty (for clearing)
                    if (value === '') {
                      this.handleTransitDaysChange('');
                      return;
                    }

                    // Allow only digits
                    if (!/^\d+$/.test(value)) return;

                    // Prevent multiple leading zeros (e.g., '00', '0000')
                    if (value.length > 1 && value.startsWith('0')) return;

                    // Ensure number > 0
                    if (parseInt(value, 10) > 0) {
                      this.handleTransitDaysChange(value);
                    }
                  }}
                  className="form-control"
                  placeholder="Enter Transit Days"
                  required
                />
              </div>
              <div className="form-actions">
                <button type="button" className="btn-cancel" onClick={this.onCloseSlider}>Cancel</button>
                <button type="submit" className="btn-send">Send</button>
              </div>
            </form>
          </div>
        </div>
        <div
          className={
            "slide-r " +
            (this.state.showBidDetailsSlider1 ? "slider-translate-50p" : "") +
            " slider-right"
          }
        >    <div className="place-bid-header">
            <span>Truck Details</span>
            <button className="close-btn" onClick={this.onCloseSlider}>×</button>
          </div>

          <div className="truck-details-body">
            <div className="indent-info">
              Indent ID&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<b>{this.state.selectedIndentData.indent_id}</b>
            </div>
            <div className="truck-details-table-container">
              {indent.started_truck_details == 1 ? (
                <table className="truck-details-table">    <thead className="table-header-blue text-white" >
                  <tr>
                    <th>S.No</th>
                    {/* <th>Indent ID</th> */}
                    <th>Dealer City</th>
                    <th>Dealer Pincode</th>
                    <th>Bid Price</th>
                    <th>Truck No</th>
                    <th>LR No/GC No</th>
                  </tr>
                </thead>
                  <tbody>
                    {this.state.lr_no_data && this.state.lr_no_data.length > 0 ? (
                      this.state.lr_no_data.map((destination, index) => (
                        <tr key={index}>
                          <td>{index + 1}</td>
                          {/* <td>{destination.indent_id || "N/A"}</td> */}
                          <td>{destination.dealer_city || "N/A"}</td>
                          <td>{destination.dealer_pincode || "N/A"}</td>
                          <td>{destination.bid_price || "N/A"}</td>
                          <td>
                            <input
                              type="text"
                              placeholder="Enter Truck No"
                              value={destination.truck_no || ""}
                              onChange={(e) =>
                                this.handleInputChangeforacceptfortruck1(index, "truck_no", e.target.value)
                              }
                              disabled={destination.lr_no ? true : false}
                              className={destination.lr_no ? "disabled-input" : ""}
                            />
                          </td>
                          <td>
                            <input
                              type="text"
                              placeholder="Enter LR No/GC No"
                              value={destination.lr_no || ""}
                              onChange={(e) =>
                                this.handleInputChangeforacceptfortruck1(index, "lr_no", e.target.value)
                              }
                              disabled={indent.lr_no_completed == 1}
                              className={destination.lr_no ? "disabled-input" : ""}
                            />
                          </td>
                        </tr>
                      ))
                    ) : (
                      <tr>
                        <td colSpan="6">No destinations available</td>
                      </tr>
                    )}
                  </tbody>
                </table>
              ) : (
                <table className="truck-details-table">
                  <thead className="table-header-blue text-white" >
                    <tr>
                      <th>S.No</th>
                      {/* <th>Indent ID</th> */}
                      <th>Dealer City</th>
                      <th>Dealer Pincode</th>
                      <th>Bid Price</th>

                      <th>Truck No</th>
                      <th>LR No/GC No</th>
                    </tr>
                  </thead>
                  <tbody>
                    {this.state.indentfortruckdetails && this.state.indentfortruckdetails.length > 0 ? (
                      this.state.indentfortruckdetails.map((destination, index) => (
                        <tr key={index}>
                          <td>{index + 1}</td>
                          {/* <td>{destination.indent_id || "N/A"}</td> */}
                          <td>{destination.dealer_city || "N/A"}</td>
                          <td>{destination.dealer_pincode || "N/A"}</td>
                          <td>{destination.bid_price || "N/A"}</td>

                          <td>
                            <input
                              type="text"
                              placeholder="Enter Truck No"
                              value={destination.truck_no || ""}
                              onChange={(e) =>
                                this.handleInputChangeforacceptfortruck(index, "truck_no", e.target.value)
                              }
                            />
                          </td>
                          <td>
                            <input
                              type="text"
                              placeholder="Enter LR No/GC No"
                              value={destination.lr_no || ""}
                              onChange={(e) =>
                                this.handleInputChangeforacceptfortruck(index, "lr_no", e.target.value)
                              }
                            />
                          </td>
                        </tr>
                      ))
                    ) : (
                      <tr>
                        <td colSpan="6">No destinations available</td>
                      </tr>
                    )}
                  </tbody>
                </table>
              )}
              {indent.lr_no_completed !== 1 ? (
                <div className="flex-end-gap">    <button
                  className="btn-cancel-outline"
                  onClick={this.onCancel}  // Add cancel handler
                >
                  Cancel
                </button>
                  <button
                    className="btn-submit-solid"
                    onClick={() => this.onSubmitdata1(indent)}
                  >
                    Submit
                  </button>
                </div>
              ) : null}
            </div>
          </div>
        </div>
        <Modal open={this.state.isPreviewMode} onClose={() => this.setState({ isPreviewMode: false })}>
          <RFQView rfqForm={rfqForm} dealers={dealers} />
        </Modal>
        <Modal
          open={this.state.modelForAdditionalComments}
          onClose={this.onCloseModal}
          center
          classNames={{ modal: 'custom-modal-fix' }}
        >
          <div className="my-modal-wrapper">
            {/* Modal Header */}
            <div className="commentmodal-header">
              Comments
            </div>
            {/* Modal Body */}
            <div className="commentmodal-body">
              <div className="commentmodal-box">
                {this.state.additionalComments.split('\n').map((line, idx) => (
                  <div key={idx} className="commentmodal-line">{line}</div>
                ))}
              </div>
            </div>

            {/* Close Button */}
            <div className="rejectclosebtn-wrapper">
              <button className="rejectclosebtn-button" onClick={this.onCloseModal}>
                Close
              </button>
            </div>
          </div>
        </Modal>
        {this.state.declineModel && (
          <div className="rejectmodal-overlay">
            <form className="rejectmodal-content" onSubmit={this.onClickdeclineparticipation1}>
              {/* Close Button Top-Right */}
              <button type="button" className="rejectmodal-close-btn" onClick={this.onCloseModal}>×</button>
              {/* Red Pin Icon */}
              <div className="rejectmodal-icon">
                <div className="rejectmodal-circle">
                  <span className="rejectmodal-cross">×</span>
                </div>
                <div className="rejectmodal-stick"></div>
              </div>
              {/* Title & Description */}
              <div className="rejectmodal-text">
                <h5>Are you sure you want to Decline the Indent ?</h5>
              </div>
              {/* Textarea */}
              <div className="rejectmodal-body">
                <label>Select Reason for Decline: <span className="text-danger">*</span></label>
                <select
                  required={true}
                  className="form-control select-item"
                  value={this.state.declinereasonforvendor}
                  onChange={(e) => this.setState({ declinereasonforvendor: e.target.value })}
                >
                  <option value="">Please select decline reason</option>
                  {this.state.declineionReasonsList.map((reason, index) => (
                    <option key={index} value={reason.value}>
                      {reason.label}
                    </option>
                  ))}
                </select>
              </div>
              {/* Reject Button */}
              <div className="reject-btn-container">
                <button type="submit" className="btn vendor-reject-btn" styles={{ height: "36px" }} >
                  Decline
                </button>
              </div>
            </form>
          </div>
        )}
        {this.state.cancelIndentModel && (
          <div className="rejectmodal-overlay">
            <form className="rejectmodal-content" onSubmit={this.onclickreject}>

              {/* Close Button Top-Right */}
              <button type='button' className="rejectmodal-close-btn" onClick={this.onCloseModal}>×</button>

              {/* Red Pin Icon */}
              <div className="rejectmodal-icon">
                <div className="rejectmodal-circle">
                  <span className="rejectmodal-cross">×</span>
                </div>
                <div className="rejectmodal-stick"></div>
              </div>

              {/* Title & Description */}
              <div className="rejectmodal-text">
                <h5>Are you sure you want to reject ?</h5>
                {/* <p>
                  Once you do this, it can’t be undone <br />
                  you won’t be able to take it back.
                </p> */}
              </div>

              {/* Textarea */}
              <div className="rejectmodal-body">
                <label>Reason: <span className="text-danger">*</span></label>
                <textarea
                  required
                  className="rejectmodal-textarea"
                  placeholder="Type the reason here..."
                  value={this.state.rejectionReasonbyapproval1}
                  onChange={(e) => this.setState({ rejectionReasonbyapproval1: e.target.value })}
                ></textarea>
              </div>

              {/* Reject Button */}
              <div className="reject-btn-container">
                <button className="btn vendor-reject-btn" style={{ height: "36px" }} type='submit'>
                  Reject
                </button>
              </div>



            </form>
          </div>
        )}
        {this.state.showConfirmationModal && (
          <div className="reviewproposed-modal-overlay">
            <div className="reviewproposed-modal-container">

              <div className="reviewproposed-modal-header">
                <span className="reviewproposed-title">Review Proposed Value</span>
                <button className="reviewproposed-close-btn" onClick={this.closeConfirmationModal}>×</button>
              </div>

              <div className="reviewproposed-modal-body">
                <div className="reviewproposed-icon">
                  <img src={require('../../assets/icons/rupee.svg')} alt="Rupee Icon" className="reviewproposed-icon-img" />
                </div>
                <h4 className="reviewproposed-subtitle">Proposed Value</h4>
                <p className="reviewproposed-message">Do you want to accept the proposed value of</p>
                <p className="reviewproposed-value">₹ {this.state.proposedValue}</p>
              </div>

              <div className="reviewproposed-modal-footer">
                <button className="reviewproposed-reject-btn" onClick={this.closeConfirmationModal}>Cancel</button>
                <button className="reviewproposed-accept-btn" onClick={() => {
                  if (this.state.confirmActionCallback) this.state.confirmActionCallback();
                  this.closeConfirmationModal();
                }}>Accept</button>
              </div>

            </div>
          </div>
        )}

        {this.state.rejectModel && (
          <div className="rejectmodal-overlay">
            <div className="rejectmodal-content">

              {/* Close Button Top-Right */}
              <button className="rejectmodal-close-btn" onClick={this.onCloseModal}>×</button>

              {/* Red Pin Icon */}
              <div className="rejectmodal-icon">
                <div className="rejectmodal-circle">
                  <span className="rejectmodal-cross">×</span>
                </div>
                <div className="rejectmodal-stick"></div>
              </div>

              {/* Title & Description */}
              <div className="rejectmodal-text">
                <h5>Are you sure you want to reject ?</h5>
                <p>
                  Once you do this, it can’t be undone <br />
                  you won’t be able to take it back.
                </p>
              </div>

              {/* Textarea */}
              <div className="rejectmodal-body">
                <label>Tell us why you’re rejecting it: <span className="text-danger">*</span></label>
                <textarea
                  className="rejectmodal-textarea"
                  placeholder="Type the reason here..."
                  value={this.state.rejectionReasonbyvendor}
                  onChange={(e) => this.setState({ rejectionReasonbyvendor: e.target.value })}
                ></textarea>
              </div>

              {/* Reject Button */}
              <div className="reject-btn-container">
                <button className="text-link-reject-btn" onClick={this.onSubmitdataforrejection}>
                  Reject
                </button>
              </div>
            </div>
          </div>
        )}
        <div className={"dataLoadpage " + (this.state.loadshow)}>
        </div>
        <div className={"dataLoadpageimg " + (this.state.loadshow)}>
          <div class="loader-box"><div class="loader-box"><div class="rotate dashed colored"></div></div></div>
        </div>
        <div className={"overlay " + (this.state.overlay)} onClick={this.onClickHideall}></div>

      </div>
    );
  }
}

export default IndentAuctionComponentforadmin;


